/* eslint-disable */
// AC v4 legacy hook wrapper: keeps useXxxQuery API; underscores preserved
import { useQuery, useLazyQuery, useMutation, useSubscription, skipToken } from '@apollo/client/react';
import * as Base from './base/graphql';

type QueryOpts<TData, TVars>        = Parameters<typeof useQuery<TData, TVars>>[1];
type LazyQueryOpts<TVars>           = Parameters<typeof useLazyQuery<any, TVars>>[1];
type MutationOpts<TData, TVars>     = Parameters<typeof useMutation<TData, TVars>>[1];
type SubscriptionOpts<TData, TVars> = Parameters<typeof useSubscription<TData, TVars>>[1];

type AnyQueryOpts        = typeof skipToken | Parameters<typeof useQuery>[1];
type AnyLazyQueryOpts    = Parameters<typeof useLazyQuery>[1];
type AnyMutationOpts     = Parameters<typeof useMutation>[1];
type AnySubscriptionOpts = Parameters<typeof useSubscription>[1];


// AuditLogs
export type UseAuditLogsQueryOptions = QueryOpts<Base.AuditLogsQuery, Base.AuditLogsQueryVariables>;
export function useAuditLogsQuery(options?: UseAuditLogsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AuditLogsQuery, Base.AuditLogsQueryVariables>(Base.AuditLogsDocument, options as any);
}
export type UseAuditLogsLazyQueryOptions = LazyQueryOpts<Base.AuditLogsQueryVariables>;
export function useAuditLogsLazyQuery(options?: UseAuditLogsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AuditLogsQuery, Base.AuditLogsQueryVariables>(Base.AuditLogsDocument, options as any);
}


// AuditLogsStream
export type UseAuditLogsStreamQueryOptions = QueryOpts<Base.AuditLogsStreamQuery, Base.AuditLogsStreamQueryVariables>;
export function useAuditLogsStreamQuery(options?: UseAuditLogsStreamQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AuditLogsStreamQuery, Base.AuditLogsStreamQueryVariables>(Base.AuditLogsStreamDocument, options as any);
}
export type UseAuditLogsStreamLazyQueryOptions = LazyQueryOpts<Base.AuditLogsStreamQueryVariables>;
export function useAuditLogsStreamLazyQuery(options?: UseAuditLogsStreamLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AuditLogsStreamQuery, Base.AuditLogsStreamQueryVariables>(Base.AuditLogsStreamDocument, options as any);
}


// ManagePermissionsData
export type UseManagePermissionsDataQueryOptions = QueryOpts<Base.ManagePermissionsDataQuery, Base.ManagePermissionsDataQueryVariables>;
export function useManagePermissionsDataQuery(options?: UseManagePermissionsDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ManagePermissionsDataQuery, Base.ManagePermissionsDataQueryVariables>(Base.ManagePermissionsDataDocument, options as any);
}
export type UseManagePermissionsDataLazyQueryOptions = LazyQueryOpts<Base.ManagePermissionsDataQueryVariables>;
export function useManagePermissionsDataLazyQuery(options?: UseManagePermissionsDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ManagePermissionsDataQuery, Base.ManagePermissionsDataQueryVariables>(Base.ManagePermissionsDataDocument, options as any);
}


// RolesByNodeId
export type UseRolesByNodeIdQueryOptions = QueryOpts<Base.RolesByNodeIdQuery, Base.RolesByNodeIdQueryVariables>;
export function useRolesByNodeIdQuery(options?: UseRolesByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.RolesByNodeIdQuery, Base.RolesByNodeIdQueryVariables>(Base.RolesByNodeIdDocument, options as any);
}
export type UseRolesByNodeIdLazyQueryOptions = LazyQueryOpts<Base.RolesByNodeIdQueryVariables>;
export function useRolesByNodeIdLazyQuery(options?: UseRolesByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.RolesByNodeIdQuery, Base.RolesByNodeIdQueryVariables>(Base.RolesByNodeIdDocument, options as any);
}


// ManagePermissionsDataByNodeId
export type UseManagePermissionsDataByNodeIdQueryOptions = QueryOpts<Base.ManagePermissionsDataByNodeIdQuery, Base.ManagePermissionsDataByNodeIdQueryVariables>;
export function useManagePermissionsDataByNodeIdQuery(options?: UseManagePermissionsDataByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ManagePermissionsDataByNodeIdQuery, Base.ManagePermissionsDataByNodeIdQueryVariables>(Base.ManagePermissionsDataByNodeIdDocument, options as any);
}
export type UseManagePermissionsDataByNodeIdLazyQueryOptions = LazyQueryOpts<Base.ManagePermissionsDataByNodeIdQueryVariables>;
export function useManagePermissionsDataByNodeIdLazyQuery(options?: UseManagePermissionsDataByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ManagePermissionsDataByNodeIdQuery, Base.ManagePermissionsDataByNodeIdQueryVariables>(Base.ManagePermissionsDataByNodeIdDocument, options as any);
}


// SecurityTargetDialogDataByNodeId
export type UseSecurityTargetDialogDataByNodeIdQueryOptions = QueryOpts<Base.SecurityTargetDialogDataByNodeIdQuery, Base.SecurityTargetDialogDataByNodeIdQueryVariables>;
export function useSecurityTargetDialogDataByNodeIdQuery(options?: UseSecurityTargetDialogDataByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.SecurityTargetDialogDataByNodeIdQuery, Base.SecurityTargetDialogDataByNodeIdQueryVariables>(Base.SecurityTargetDialogDataByNodeIdDocument, options as any);
}
export type UseSecurityTargetDialogDataByNodeIdLazyQueryOptions = LazyQueryOpts<Base.SecurityTargetDialogDataByNodeIdQueryVariables>;
export function useSecurityTargetDialogDataByNodeIdLazyQuery(options?: UseSecurityTargetDialogDataByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.SecurityTargetDialogDataByNodeIdQuery, Base.SecurityTargetDialogDataByNodeIdQueryVariables>(Base.SecurityTargetDialogDataByNodeIdDocument, options as any);
}


// SecurityTargetsOnNode
export type UseSecurityTargetsOnNodeQueryOptions = QueryOpts<Base.SecurityTargetsOnNodeQuery, Base.SecurityTargetsOnNodeQueryVariables>;
export function useSecurityTargetsOnNodeQuery(options?: UseSecurityTargetsOnNodeQueryOptions | AnyQueryOpts) {
  return useQuery<Base.SecurityTargetsOnNodeQuery, Base.SecurityTargetsOnNodeQueryVariables>(Base.SecurityTargetsOnNodeDocument, options as any);
}
export type UseSecurityTargetsOnNodeLazyQueryOptions = LazyQueryOpts<Base.SecurityTargetsOnNodeQueryVariables>;
export function useSecurityTargetsOnNodeLazyQuery(options?: UseSecurityTargetsOnNodeLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.SecurityTargetsOnNodeQuery, Base.SecurityTargetsOnNodeQueryVariables>(Base.SecurityTargetsOnNodeDocument, options as any);
}


// SecurityTargetAdditionalData
export type UseSecurityTargetAdditionalDataQueryOptions = QueryOpts<Base.SecurityTargetAdditionalDataQuery, Base.SecurityTargetAdditionalDataQueryVariables>;
export function useSecurityTargetAdditionalDataQuery(options?: UseSecurityTargetAdditionalDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.SecurityTargetAdditionalDataQuery, Base.SecurityTargetAdditionalDataQueryVariables>(Base.SecurityTargetAdditionalDataDocument, options as any);
}
export type UseSecurityTargetAdditionalDataLazyQueryOptions = LazyQueryOpts<Base.SecurityTargetAdditionalDataQueryVariables>;
export function useSecurityTargetAdditionalDataLazyQuery(options?: UseSecurityTargetAdditionalDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.SecurityTargetAdditionalDataQuery, Base.SecurityTargetAdditionalDataQueryVariables>(Base.SecurityTargetAdditionalDataDocument, options as any);
}


// AddSecurityTargetByNodeId
export type UseAddSecurityTargetByNodeIdMutationOptions = MutationOpts<Base.AddSecurityTargetByNodeIdMutation, Base.AddSecurityTargetByNodeIdMutationVariables>;
export function useAddSecurityTargetByNodeIdMutation(options?: UseAddSecurityTargetByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddSecurityTargetByNodeIdMutation, Base.AddSecurityTargetByNodeIdMutationVariables>(Base.AddSecurityTargetByNodeIdDocument, options as any);
}


// DeleteSecurityTarget
export type UseDeleteSecurityTargetMutationOptions = MutationOpts<Base.DeleteSecurityTargetMutation, Base.DeleteSecurityTargetMutationVariables>;
export function useDeleteSecurityTargetMutation(options?: UseDeleteSecurityTargetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteSecurityTargetMutation, Base.DeleteSecurityTargetMutationVariables>(Base.DeleteSecurityTargetDocument, options as any);
}


// DeleteSecurityTargetByNodeId
export type UseDeleteSecurityTargetByNodeIdMutationOptions = MutationOpts<Base.DeleteSecurityTargetByNodeIdMutation, Base.DeleteSecurityTargetByNodeIdMutationVariables>;
export function useDeleteSecurityTargetByNodeIdMutation(options?: UseDeleteSecurityTargetByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteSecurityTargetByNodeIdMutation, Base.DeleteSecurityTargetByNodeIdMutationVariables>(Base.DeleteSecurityTargetByNodeIdDocument, options as any);
}


// Permissions
export type UsePermissionsQueryOptions = QueryOpts<Base.PermissionsQuery, Base.PermissionsQueryVariables>;
export function usePermissionsQuery(options?: UsePermissionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PermissionsQuery, Base.PermissionsQueryVariables>(Base.PermissionsDocument, options as any);
}
export type UsePermissionsLazyQueryOptions = LazyQueryOpts<Base.PermissionsQueryVariables>;
export function usePermissionsLazyQuery(options?: UsePermissionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PermissionsQuery, Base.PermissionsQueryVariables>(Base.PermissionsDocument, options as any);
}


// PermissionsByNodeId
export type UsePermissionsByNodeIdQueryOptions = QueryOpts<Base.PermissionsByNodeIdQuery, Base.PermissionsByNodeIdQueryVariables>;
export function usePermissionsByNodeIdQuery(options?: UsePermissionsByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PermissionsByNodeIdQuery, Base.PermissionsByNodeIdQueryVariables>(Base.PermissionsByNodeIdDocument, options as any);
}
export type UsePermissionsByNodeIdLazyQueryOptions = LazyQueryOpts<Base.PermissionsByNodeIdQueryVariables>;
export function usePermissionsByNodeIdLazyQuery(options?: UsePermissionsByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PermissionsByNodeIdQuery, Base.PermissionsByNodeIdQueryVariables>(Base.PermissionsByNodeIdDocument, options as any);
}


// PermissionsByRole
export type UsePermissionsByRoleQueryOptions = QueryOpts<Base.PermissionsByRoleQuery, Base.PermissionsByRoleQueryVariables>;
export function usePermissionsByRoleQuery(options?: UsePermissionsByRoleQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PermissionsByRoleQuery, Base.PermissionsByRoleQueryVariables>(Base.PermissionsByRoleDocument, options as any);
}
export type UsePermissionsByRoleLazyQueryOptions = LazyQueryOpts<Base.PermissionsByRoleQueryVariables>;
export function usePermissionsByRoleLazyQuery(options?: UsePermissionsByRoleLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PermissionsByRoleQuery, Base.PermissionsByRoleQueryVariables>(Base.PermissionsByRoleDocument, options as any);
}


// PermissionsByRoleByNodeId
export type UsePermissionsByRoleByNodeIdQueryOptions = QueryOpts<Base.PermissionsByRoleByNodeIdQuery, Base.PermissionsByRoleByNodeIdQueryVariables>;
export function usePermissionsByRoleByNodeIdQuery(options?: UsePermissionsByRoleByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PermissionsByRoleByNodeIdQuery, Base.PermissionsByRoleByNodeIdQueryVariables>(Base.PermissionsByRoleByNodeIdDocument, options as any);
}
export type UsePermissionsByRoleByNodeIdLazyQueryOptions = LazyQueryOpts<Base.PermissionsByRoleByNodeIdQueryVariables>;
export function usePermissionsByRoleByNodeIdLazyQuery(options?: UsePermissionsByRoleByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PermissionsByRoleByNodeIdQuery, Base.PermissionsByRoleByNodeIdQueryVariables>(Base.PermissionsByRoleByNodeIdDocument, options as any);
}


// AddRole
export type UseAddRoleMutationOptions = MutationOpts<Base.AddRoleMutation, Base.AddRoleMutationVariables>;
export function useAddRoleMutation(options?: UseAddRoleMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddRoleMutation, Base.AddRoleMutationVariables>(Base.AddRoleDocument, options as any);
}


// AddRoleByNodeId
export type UseAddRoleByNodeIdMutationOptions = MutationOpts<Base.AddRoleByNodeIdMutation, Base.AddRoleByNodeIdMutationVariables>;
export function useAddRoleByNodeIdMutation(options?: UseAddRoleByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddRoleByNodeIdMutation, Base.AddRoleByNodeIdMutationVariables>(Base.AddRoleByNodeIdDocument, options as any);
}


// DeleteRole
export type UseDeleteRoleMutationOptions = MutationOpts<Base.DeleteRoleMutation, Base.DeleteRoleMutationVariables>;
export function useDeleteRoleMutation(options?: UseDeleteRoleMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteRoleMutation, Base.DeleteRoleMutationVariables>(Base.DeleteRoleDocument, options as any);
}


// DeleteRoleByNodeId
export type UseDeleteRoleByNodeIdMutationOptions = MutationOpts<Base.DeleteRoleByNodeIdMutation, Base.DeleteRoleByNodeIdMutationVariables>;
export function useDeleteRoleByNodeIdMutation(options?: UseDeleteRoleByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteRoleByNodeIdMutation, Base.DeleteRoleByNodeIdMutationVariables>(Base.DeleteRoleByNodeIdDocument, options as any);
}


// AssignRolePrivilege
export type UseAssignRolePrivilegeMutationOptions = MutationOpts<Base.AssignRolePrivilegeMutation, Base.AssignRolePrivilegeMutationVariables>;
export function useAssignRolePrivilegeMutation(options?: UseAssignRolePrivilegeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AssignRolePrivilegeMutation, Base.AssignRolePrivilegeMutationVariables>(Base.AssignRolePrivilegeDocument, options as any);
}


// AssignRolePrivilegeByNodeId
export type UseAssignRolePrivilegeByNodeIdMutationOptions = MutationOpts<Base.AssignRolePrivilegeByNodeIdMutation, Base.AssignRolePrivilegeByNodeIdMutationVariables>;
export function useAssignRolePrivilegeByNodeIdMutation(options?: UseAssignRolePrivilegeByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AssignRolePrivilegeByNodeIdMutation, Base.AssignRolePrivilegeByNodeIdMutationVariables>(Base.AssignRolePrivilegeByNodeIdDocument, options as any);
}


// RemoveRolePrivilege
export type UseRemoveRolePrivilegeMutationOptions = MutationOpts<Base.RemoveRolePrivilegeMutation, Base.RemoveRolePrivilegeMutationVariables>;
export function useRemoveRolePrivilegeMutation(options?: UseRemoveRolePrivilegeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RemoveRolePrivilegeMutation, Base.RemoveRolePrivilegeMutationVariables>(Base.RemoveRolePrivilegeDocument, options as any);
}


// RemoveRolePrivilegeByNodeId
export type UseRemoveRolePrivilegeByNodeIdMutationOptions = MutationOpts<Base.RemoveRolePrivilegeByNodeIdMutation, Base.RemoveRolePrivilegeByNodeIdMutationVariables>;
export function useRemoveRolePrivilegeByNodeIdMutation(options?: UseRemoveRolePrivilegeByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RemoveRolePrivilegeByNodeIdMutation, Base.RemoveRolePrivilegeByNodeIdMutationVariables>(Base.RemoveRolePrivilegeByNodeIdDocument, options as any);
}


// UploadStatus
export type UseUploadStatusQueryOptions = QueryOpts<Base.UploadStatusQuery, Base.UploadStatusQueryVariables>;
export function useUploadStatusQuery(options?: UseUploadStatusQueryOptions | AnyQueryOpts) {
  return useQuery<Base.UploadStatusQuery, Base.UploadStatusQueryVariables>(Base.UploadStatusDocument, options as any);
}
export type UseUploadStatusLazyQueryOptions = LazyQueryOpts<Base.UploadStatusQueryVariables>;
export function useUploadStatusLazyQuery(options?: UseUploadStatusLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.UploadStatusQuery, Base.UploadStatusQueryVariables>(Base.UploadStatusDocument, options as any);
}


// UploadStatusByNodeId
export type UseUploadStatusByNodeIdQueryOptions = QueryOpts<Base.UploadStatusByNodeIdQuery, Base.UploadStatusByNodeIdQueryVariables>;
export function useUploadStatusByNodeIdQuery(options?: UseUploadStatusByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.UploadStatusByNodeIdQuery, Base.UploadStatusByNodeIdQueryVariables>(Base.UploadStatusByNodeIdDocument, options as any);
}
export type UseUploadStatusByNodeIdLazyQueryOptions = LazyQueryOpts<Base.UploadStatusByNodeIdQueryVariables>;
export function useUploadStatusByNodeIdLazyQuery(options?: UseUploadStatusByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.UploadStatusByNodeIdQuery, Base.UploadStatusByNodeIdQueryVariables>(Base.UploadStatusByNodeIdDocument, options as any);
}


// IdentityLabelUser
export type UseIdentityLabelUserQueryOptions = QueryOpts<Base.IdentityLabelUserQuery, Base.IdentityLabelUserQueryVariables>;
export function useIdentityLabelUserQuery(options?: UseIdentityLabelUserQueryOptions | AnyQueryOpts) {
  return useQuery<Base.IdentityLabelUserQuery, Base.IdentityLabelUserQueryVariables>(Base.IdentityLabelUserDocument, options as any);
}
export type UseIdentityLabelUserLazyQueryOptions = LazyQueryOpts<Base.IdentityLabelUserQueryVariables>;
export function useIdentityLabelUserLazyQuery(options?: UseIdentityLabelUserLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.IdentityLabelUserQuery, Base.IdentityLabelUserQueryVariables>(Base.IdentityLabelUserDocument, options as any);
}


// Tenant
export type UseTenantQueryOptions = QueryOpts<Base.TenantQuery, Base.TenantQueryVariables>;
export function useTenantQuery(options?: UseTenantQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TenantQuery, Base.TenantQueryVariables>(Base.TenantDocument, options as any);
}
export type UseTenantLazyQueryOptions = LazyQueryOpts<Base.TenantQueryVariables>;
export function useTenantLazyQuery(options?: UseTenantLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TenantQuery, Base.TenantQueryVariables>(Base.TenantDocument, options as any);
}


// GetCurrentOrganisation
export type UseGetCurrentOrganisationQueryOptions = QueryOpts<Base.GetCurrentOrganisationQuery, Base.GetCurrentOrganisationQueryVariables>;
export function useGetCurrentOrganisationQuery(options?: UseGetCurrentOrganisationQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetCurrentOrganisationQuery, Base.GetCurrentOrganisationQueryVariables>(Base.GetCurrentOrganisationDocument, options as any);
}
export type UseGetCurrentOrganisationLazyQueryOptions = LazyQueryOpts<Base.GetCurrentOrganisationQueryVariables>;
export function useGetCurrentOrganisationLazyQuery(options?: UseGetCurrentOrganisationLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetCurrentOrganisationQuery, Base.GetCurrentOrganisationQueryVariables>(Base.GetCurrentOrganisationDocument, options as any);
}


// GetStructuralNodes
export type UseGetStructuralNodesQueryOptions = QueryOpts<Base.GetStructuralNodesQuery, Base.GetStructuralNodesQueryVariables>;
export function useGetStructuralNodesQuery(options?: UseGetStructuralNodesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetStructuralNodesQuery, Base.GetStructuralNodesQueryVariables>(Base.GetStructuralNodesDocument, options as any);
}
export type UseGetStructuralNodesLazyQueryOptions = LazyQueryOpts<Base.GetStructuralNodesQueryVariables>;
export function useGetStructuralNodesLazyQuery(options?: UseGetStructuralNodesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetStructuralNodesQuery, Base.GetStructuralNodesQueryVariables>(Base.GetStructuralNodesDocument, options as any);
}


// Nodes
export type UseNodesQueryOptions = QueryOpts<Base.NodesQuery, Base.NodesQueryVariables>;
export function useNodesQuery(options?: UseNodesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodesQuery, Base.NodesQueryVariables>(Base.NodesDocument, options as any);
}
export type UseNodesLazyQueryOptions = LazyQueryOpts<Base.NodesQueryVariables>;
export function useNodesLazyQuery(options?: UseNodesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodesQuery, Base.NodesQueryVariables>(Base.NodesDocument, options as any);
}


// NodeTreeNodes
export type UseNodeTreeNodesQueryOptions = QueryOpts<Base.NodeTreeNodesQuery, Base.NodeTreeNodesQueryVariables>;
export function useNodeTreeNodesQuery(options?: UseNodeTreeNodesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodeTreeNodesQuery, Base.NodeTreeNodesQueryVariables>(Base.NodeTreeNodesDocument, options as any);
}
export type UseNodeTreeNodesLazyQueryOptions = LazyQueryOpts<Base.NodeTreeNodesQueryVariables>;
export function useNodeTreeNodesLazyQuery(options?: UseNodeTreeNodesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodeTreeNodesQuery, Base.NodeTreeNodesQueryVariables>(Base.NodeTreeNodesDocument, options as any);
}


// DeviceFileTypes
export type UseDeviceFileTypesQueryOptions = QueryOpts<Base.DeviceFileTypesQuery, Base.DeviceFileTypesQueryVariables>;
export function useDeviceFileTypesQuery(options?: UseDeviceFileTypesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceFileTypesQuery, Base.DeviceFileTypesQueryVariables>(Base.DeviceFileTypesDocument, options as any);
}
export type UseDeviceFileTypesLazyQueryOptions = LazyQueryOpts<Base.DeviceFileTypesQueryVariables>;
export function useDeviceFileTypesLazyQuery(options?: UseDeviceFileTypesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceFileTypesQuery, Base.DeviceFileTypesQueryVariables>(Base.DeviceFileTypesDocument, options as any);
}


// DeviceFamilies
export type UseDeviceFamiliesQueryOptions = QueryOpts<Base.DeviceFamiliesQuery, Base.DeviceFamiliesQueryVariables>;
export function useDeviceFamiliesQuery(options?: UseDeviceFamiliesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceFamiliesQuery, Base.DeviceFamiliesQueryVariables>(Base.DeviceFamiliesDocument, options as any);
}
export type UseDeviceFamiliesLazyQueryOptions = LazyQueryOpts<Base.DeviceFamiliesQueryVariables>;
export function useDeviceFamiliesLazyQuery(options?: UseDeviceFamiliesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceFamiliesQuery, Base.DeviceFamiliesQueryVariables>(Base.DeviceFamiliesDocument, options as any);
}


// Chat
export type UseChatQueryOptions = QueryOpts<Base.ChatQuery, Base.ChatQueryVariables>;
export function useChatQuery(options?: UseChatQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ChatQuery, Base.ChatQueryVariables>(Base.ChatDocument, options as any);
}
export type UseChatLazyQueryOptions = LazyQueryOpts<Base.ChatQueryVariables>;
export function useChatLazyQuery(options?: UseChatLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ChatQuery, Base.ChatQueryVariables>(Base.ChatDocument, options as any);
}


// ImportComponent
export type UseImportComponentQueryOptions = QueryOpts<Base.ImportComponentQuery, Base.ImportComponentQueryVariables>;
export function useImportComponentQuery(options?: UseImportComponentQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportComponentQuery, Base.ImportComponentQueryVariables>(Base.ImportComponentDocument, options as any);
}
export type UseImportComponentLazyQueryOptions = LazyQueryOpts<Base.ImportComponentQueryVariables>;
export function useImportComponentLazyQuery(options?: UseImportComponentLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportComponentQuery, Base.ImportComponentQueryVariables>(Base.ImportComponentDocument, options as any);
}


// ImportComponentNames
export type UseImportComponentNamesQueryOptions = QueryOpts<Base.ImportComponentNamesQuery, Base.ImportComponentNamesQueryVariables>;
export function useImportComponentNamesQuery(options?: UseImportComponentNamesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportComponentNamesQuery, Base.ImportComponentNamesQueryVariables>(Base.ImportComponentNamesDocument, options as any);
}
export type UseImportComponentNamesLazyQueryOptions = LazyQueryOpts<Base.ImportComponentNamesQueryVariables>;
export function useImportComponentNamesLazyQuery(options?: UseImportComponentNamesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportComponentNamesQuery, Base.ImportComponentNamesQueryVariables>(Base.ImportComponentNamesDocument, options as any);
}


// AddImportComponent
export type UseAddImportComponentMutationOptions = MutationOpts<Base.AddImportComponentMutation, Base.AddImportComponentMutationVariables>;
export function useAddImportComponentMutation(options?: UseAddImportComponentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddImportComponentMutation, Base.AddImportComponentMutationVariables>(Base.AddImportComponentDocument, options as any);
}


// UpdateImportComponent
export type UseUpdateImportComponentMutationOptions = MutationOpts<Base.UpdateImportComponentMutation, Base.UpdateImportComponentMutationVariables>;
export function useUpdateImportComponentMutation(options?: UseUpdateImportComponentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateImportComponentMutation, Base.UpdateImportComponentMutationVariables>(Base.UpdateImportComponentDocument, options as any);
}


// DeleteImportComponent
export type UseDeleteImportComponentMutationOptions = MutationOpts<Base.DeleteImportComponentMutation, Base.DeleteImportComponentMutationVariables>;
export function useDeleteImportComponentMutation(options?: UseDeleteImportComponentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteImportComponentMutation, Base.DeleteImportComponentMutationVariables>(Base.DeleteImportComponentDocument, options as any);
}


// ExportComponent
export type UseExportComponentQueryOptions = QueryOpts<Base.ExportComponentQuery, Base.ExportComponentQueryVariables>;
export function useExportComponentQuery(options?: UseExportComponentQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportComponentQuery, Base.ExportComponentQueryVariables>(Base.ExportComponentDocument, options as any);
}
export type UseExportComponentLazyQueryOptions = LazyQueryOpts<Base.ExportComponentQueryVariables>;
export function useExportComponentLazyQuery(options?: UseExportComponentLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportComponentQuery, Base.ExportComponentQueryVariables>(Base.ExportComponentDocument, options as any);
}


// ExportComponentNames
export type UseExportComponentNamesQueryOptions = QueryOpts<Base.ExportComponentNamesQuery, Base.ExportComponentNamesQueryVariables>;
export function useExportComponentNamesQuery(options?: UseExportComponentNamesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportComponentNamesQuery, Base.ExportComponentNamesQueryVariables>(Base.ExportComponentNamesDocument, options as any);
}
export type UseExportComponentNamesLazyQueryOptions = LazyQueryOpts<Base.ExportComponentNamesQueryVariables>;
export function useExportComponentNamesLazyQuery(options?: UseExportComponentNamesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportComponentNamesQuery, Base.ExportComponentNamesQueryVariables>(Base.ExportComponentNamesDocument, options as any);
}


// AddExportComponent
export type UseAddExportComponentMutationOptions = MutationOpts<Base.AddExportComponentMutation, Base.AddExportComponentMutationVariables>;
export function useAddExportComponentMutation(options?: UseAddExportComponentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExportComponentMutation, Base.AddExportComponentMutationVariables>(Base.AddExportComponentDocument, options as any);
}


// UpdateExportComponent
export type UseUpdateExportComponentMutationOptions = MutationOpts<Base.UpdateExportComponentMutation, Base.UpdateExportComponentMutationVariables>;
export function useUpdateExportComponentMutation(options?: UseUpdateExportComponentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExportComponentMutation, Base.UpdateExportComponentMutationVariables>(Base.UpdateExportComponentDocument, options as any);
}


// DeleteExportComponent
export type UseDeleteExportComponentMutationOptions = MutationOpts<Base.DeleteExportComponentMutation, Base.DeleteExportComponentMutationVariables>;
export function useDeleteExportComponentMutation(options?: UseDeleteExportComponentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExportComponentMutation, Base.DeleteExportComponentMutationVariables>(Base.DeleteExportComponentDocument, options as any);
}


// ExportComponentConnectors
export type UseExportComponentConnectorsQueryOptions = QueryOpts<Base.ExportComponentConnectorsQuery, Base.ExportComponentConnectorsQueryVariables>;
export function useExportComponentConnectorsQuery(options?: UseExportComponentConnectorsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportComponentConnectorsQuery, Base.ExportComponentConnectorsQueryVariables>(Base.ExportComponentConnectorsDocument, options as any);
}
export type UseExportComponentConnectorsLazyQueryOptions = LazyQueryOpts<Base.ExportComponentConnectorsQueryVariables>;
export function useExportComponentConnectorsLazyQuery(options?: UseExportComponentConnectorsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportComponentConnectorsQuery, Base.ExportComponentConnectorsQueryVariables>(Base.ExportComponentConnectorsDocument, options as any);
}


// AddExportComponentConnector
export type UseAddExportComponentConnectorMutationOptions = MutationOpts<Base.AddExportComponentConnectorMutation, Base.AddExportComponentConnectorMutationVariables>;
export function useAddExportComponentConnectorMutation(options?: UseAddExportComponentConnectorMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExportComponentConnectorMutation, Base.AddExportComponentConnectorMutationVariables>(Base.AddExportComponentConnectorDocument, options as any);
}


// UpdateExportComponentConnector
export type UseUpdateExportComponentConnectorMutationOptions = MutationOpts<Base.UpdateExportComponentConnectorMutation, Base.UpdateExportComponentConnectorMutationVariables>;
export function useUpdateExportComponentConnectorMutation(options?: UseUpdateExportComponentConnectorMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExportComponentConnectorMutation, Base.UpdateExportComponentConnectorMutationVariables>(Base.UpdateExportComponentConnectorDocument, options as any);
}


// DeleteExportComponentConnector
export type UseDeleteExportComponentConnectorMutationOptions = MutationOpts<Base.DeleteExportComponentConnectorMutation, Base.DeleteExportComponentConnectorMutationVariables>;
export function useDeleteExportComponentConnectorMutation(options?: UseDeleteExportComponentConnectorMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExportComponentConnectorMutation, Base.DeleteExportComponentConnectorMutationVariables>(Base.DeleteExportComponentConnectorDocument, options as any);
}


// ImportComponentProperty
export type UseImportComponentPropertyQueryOptions = QueryOpts<Base.ImportComponentPropertyQuery, Base.ImportComponentPropertyQueryVariables>;
export function useImportComponentPropertyQuery(options?: UseImportComponentPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportComponentPropertyQuery, Base.ImportComponentPropertyQueryVariables>(Base.ImportComponentPropertyDocument, options as any);
}
export type UseImportComponentPropertyLazyQueryOptions = LazyQueryOpts<Base.ImportComponentPropertyQueryVariables>;
export function useImportComponentPropertyLazyQuery(options?: UseImportComponentPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportComponentPropertyQuery, Base.ImportComponentPropertyQueryVariables>(Base.ImportComponentPropertyDocument, options as any);
}


// AddImportComponentProperty
export type UseAddImportComponentPropertyMutationOptions = MutationOpts<Base.AddImportComponentPropertyMutation, Base.AddImportComponentPropertyMutationVariables>;
export function useAddImportComponentPropertyMutation(options?: UseAddImportComponentPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddImportComponentPropertyMutation, Base.AddImportComponentPropertyMutationVariables>(Base.AddImportComponentPropertyDocument, options as any);
}


// UpdateImportComponentProperty
export type UseUpdateImportComponentPropertyMutationOptions = MutationOpts<Base.UpdateImportComponentPropertyMutation, Base.UpdateImportComponentPropertyMutationVariables>;
export function useUpdateImportComponentPropertyMutation(options?: UseUpdateImportComponentPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateImportComponentPropertyMutation, Base.UpdateImportComponentPropertyMutationVariables>(Base.UpdateImportComponentPropertyDocument, options as any);
}


// DeleteImportComponentProperty
export type UseDeleteImportComponentPropertyMutationOptions = MutationOpts<Base.DeleteImportComponentPropertyMutation, Base.DeleteImportComponentPropertyMutationVariables>;
export function useDeleteImportComponentPropertyMutation(options?: UseDeleteImportComponentPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteImportComponentPropertyMutation, Base.DeleteImportComponentPropertyMutationVariables>(Base.DeleteImportComponentPropertyDocument, options as any);
}


// ExportComponentProperty
export type UseExportComponentPropertyQueryOptions = QueryOpts<Base.ExportComponentPropertyQuery, Base.ExportComponentPropertyQueryVariables>;
export function useExportComponentPropertyQuery(options?: UseExportComponentPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportComponentPropertyQuery, Base.ExportComponentPropertyQueryVariables>(Base.ExportComponentPropertyDocument, options as any);
}
export type UseExportComponentPropertyLazyQueryOptions = LazyQueryOpts<Base.ExportComponentPropertyQueryVariables>;
export function useExportComponentPropertyLazyQuery(options?: UseExportComponentPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportComponentPropertyQuery, Base.ExportComponentPropertyQueryVariables>(Base.ExportComponentPropertyDocument, options as any);
}


// AddExportComponentProperty
export type UseAddExportComponentPropertyMutationOptions = MutationOpts<Base.AddExportComponentPropertyMutation, Base.AddExportComponentPropertyMutationVariables>;
export function useAddExportComponentPropertyMutation(options?: UseAddExportComponentPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExportComponentPropertyMutation, Base.AddExportComponentPropertyMutationVariables>(Base.AddExportComponentPropertyDocument, options as any);
}


// UpdateExportComponentProperty
export type UseUpdateExportComponentPropertyMutationOptions = MutationOpts<Base.UpdateExportComponentPropertyMutation, Base.UpdateExportComponentPropertyMutationVariables>;
export function useUpdateExportComponentPropertyMutation(options?: UseUpdateExportComponentPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExportComponentPropertyMutation, Base.UpdateExportComponentPropertyMutationVariables>(Base.UpdateExportComponentPropertyDocument, options as any);
}


// DeleteExportComponentProperty
export type UseDeleteExportComponentPropertyMutationOptions = MutationOpts<Base.DeleteExportComponentPropertyMutation, Base.DeleteExportComponentPropertyMutationVariables>;
export function useDeleteExportComponentPropertyMutation(options?: UseDeleteExportComponentPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExportComponentPropertyMutation, Base.DeleteExportComponentPropertyMutationVariables>(Base.DeleteExportComponentPropertyDocument, options as any);
}


// ImportComponentJobProperty
export type UseImportComponentJobPropertyQueryOptions = QueryOpts<Base.ImportComponentJobPropertyQuery, Base.ImportComponentJobPropertyQueryVariables>;
export function useImportComponentJobPropertyQuery(options?: UseImportComponentJobPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportComponentJobPropertyQuery, Base.ImportComponentJobPropertyQueryVariables>(Base.ImportComponentJobPropertyDocument, options as any);
}
export type UseImportComponentJobPropertyLazyQueryOptions = LazyQueryOpts<Base.ImportComponentJobPropertyQueryVariables>;
export function useImportComponentJobPropertyLazyQuery(options?: UseImportComponentJobPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportComponentJobPropertyQuery, Base.ImportComponentJobPropertyQueryVariables>(Base.ImportComponentJobPropertyDocument, options as any);
}


// AddImportComponentJobProperty
export type UseAddImportComponentJobPropertyMutationOptions = MutationOpts<Base.AddImportComponentJobPropertyMutation, Base.AddImportComponentJobPropertyMutationVariables>;
export function useAddImportComponentJobPropertyMutation(options?: UseAddImportComponentJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddImportComponentJobPropertyMutation, Base.AddImportComponentJobPropertyMutationVariables>(Base.AddImportComponentJobPropertyDocument, options as any);
}


// UpdateImportComponentJobProperty
export type UseUpdateImportComponentJobPropertyMutationOptions = MutationOpts<Base.UpdateImportComponentJobPropertyMutation, Base.UpdateImportComponentJobPropertyMutationVariables>;
export function useUpdateImportComponentJobPropertyMutation(options?: UseUpdateImportComponentJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateImportComponentJobPropertyMutation, Base.UpdateImportComponentJobPropertyMutationVariables>(Base.UpdateImportComponentJobPropertyDocument, options as any);
}


// DeleteImportComponentJobProperty
export type UseDeleteImportComponentJobPropertyMutationOptions = MutationOpts<Base.DeleteImportComponentJobPropertyMutation, Base.DeleteImportComponentJobPropertyMutationVariables>;
export function useDeleteImportComponentJobPropertyMutation(options?: UseDeleteImportComponentJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteImportComponentJobPropertyMutation, Base.DeleteImportComponentJobPropertyMutationVariables>(Base.DeleteImportComponentJobPropertyDocument, options as any);
}


// ExportComponentJobProperty
export type UseExportComponentJobPropertyQueryOptions = QueryOpts<Base.ExportComponentJobPropertyQuery, Base.ExportComponentJobPropertyQueryVariables>;
export function useExportComponentJobPropertyQuery(options?: UseExportComponentJobPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportComponentJobPropertyQuery, Base.ExportComponentJobPropertyQueryVariables>(Base.ExportComponentJobPropertyDocument, options as any);
}
export type UseExportComponentJobPropertyLazyQueryOptions = LazyQueryOpts<Base.ExportComponentJobPropertyQueryVariables>;
export function useExportComponentJobPropertyLazyQuery(options?: UseExportComponentJobPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportComponentJobPropertyQuery, Base.ExportComponentJobPropertyQueryVariables>(Base.ExportComponentJobPropertyDocument, options as any);
}


// AddExportComponentJobProperty
export type UseAddExportComponentJobPropertyMutationOptions = MutationOpts<Base.AddExportComponentJobPropertyMutation, Base.AddExportComponentJobPropertyMutationVariables>;
export function useAddExportComponentJobPropertyMutation(options?: UseAddExportComponentJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExportComponentJobPropertyMutation, Base.AddExportComponentJobPropertyMutationVariables>(Base.AddExportComponentJobPropertyDocument, options as any);
}


// UpdateExportComponentJobProperty
export type UseUpdateExportComponentJobPropertyMutationOptions = MutationOpts<Base.UpdateExportComponentJobPropertyMutation, Base.UpdateExportComponentJobPropertyMutationVariables>;
export function useUpdateExportComponentJobPropertyMutation(options?: UseUpdateExportComponentJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExportComponentJobPropertyMutation, Base.UpdateExportComponentJobPropertyMutationVariables>(Base.UpdateExportComponentJobPropertyDocument, options as any);
}


// DeleteExportComponentJobProperty
export type UseDeleteExportComponentJobPropertyMutationOptions = MutationOpts<Base.DeleteExportComponentJobPropertyMutation, Base.DeleteExportComponentJobPropertyMutationVariables>;
export function useDeleteExportComponentJobPropertyMutation(options?: UseDeleteExportComponentJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExportComponentJobPropertyMutation, Base.DeleteExportComponentJobPropertyMutationVariables>(Base.DeleteExportComponentJobPropertyDocument, options as any);
}


// ExportJob
export type UseExportJobQueryOptions = QueryOpts<Base.ExportJobQuery, Base.ExportJobQueryVariables>;
export function useExportJobQuery(options?: UseExportJobQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportJobQuery, Base.ExportJobQueryVariables>(Base.ExportJobDocument, options as any);
}
export type UseExportJobLazyQueryOptions = LazyQueryOpts<Base.ExportJobQueryVariables>;
export function useExportJobLazyQuery(options?: UseExportJobLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportJobQuery, Base.ExportJobQueryVariables>(Base.ExportJobDocument, options as any);
}


// AddExportJob
export type UseAddExportJobMutationOptions = MutationOpts<Base.AddExportJobMutation, Base.AddExportJobMutationVariables>;
export function useAddExportJobMutation(options?: UseAddExportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExportJobMutation, Base.AddExportJobMutationVariables>(Base.AddExportJobDocument, options as any);
}


// UpdateExportJob
export type UseUpdateExportJobMutationOptions = MutationOpts<Base.UpdateExportJobMutation, Base.UpdateExportJobMutationVariables>;
export function useUpdateExportJobMutation(options?: UseUpdateExportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExportJobMutation, Base.UpdateExportJobMutationVariables>(Base.UpdateExportJobDocument, options as any);
}


// DeleteExportJob
export type UseDeleteExportJobMutationOptions = MutationOpts<Base.DeleteExportJobMutation, Base.DeleteExportJobMutationVariables>;
export function useDeleteExportJobMutation(options?: UseDeleteExportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExportJobMutation, Base.DeleteExportJobMutationVariables>(Base.DeleteExportJobDocument, options as any);
}


// ExportJobProperty
export type UseExportJobPropertyQueryOptions = QueryOpts<Base.ExportJobPropertyQuery, Base.ExportJobPropertyQueryVariables>;
export function useExportJobPropertyQuery(options?: UseExportJobPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExportJobPropertyQuery, Base.ExportJobPropertyQueryVariables>(Base.ExportJobPropertyDocument, options as any);
}
export type UseExportJobPropertyLazyQueryOptions = LazyQueryOpts<Base.ExportJobPropertyQueryVariables>;
export function useExportJobPropertyLazyQuery(options?: UseExportJobPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExportJobPropertyQuery, Base.ExportJobPropertyQueryVariables>(Base.ExportJobPropertyDocument, options as any);
}


// AddExportJobProperty
export type UseAddExportJobPropertyMutationOptions = MutationOpts<Base.AddExportJobPropertyMutation, Base.AddExportJobPropertyMutationVariables>;
export function useAddExportJobPropertyMutation(options?: UseAddExportJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExportJobPropertyMutation, Base.AddExportJobPropertyMutationVariables>(Base.AddExportJobPropertyDocument, options as any);
}


// UpdateExportJobProperty
export type UseUpdateExportJobPropertyMutationOptions = MutationOpts<Base.UpdateExportJobPropertyMutation, Base.UpdateExportJobPropertyMutationVariables>;
export function useUpdateExportJobPropertyMutation(options?: UseUpdateExportJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExportJobPropertyMutation, Base.UpdateExportJobPropertyMutationVariables>(Base.UpdateExportJobPropertyDocument, options as any);
}


// DeleteExportJobProperty
export type UseDeleteExportJobPropertyMutationOptions = MutationOpts<Base.DeleteExportJobPropertyMutation, Base.DeleteExportJobPropertyMutationVariables>;
export function useDeleteExportJobPropertyMutation(options?: UseDeleteExportJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExportJobPropertyMutation, Base.DeleteExportJobPropertyMutationVariables>(Base.DeleteExportJobPropertyDocument, options as any);
}


// ImportJob
export type UseImportJobQueryOptions = QueryOpts<Base.ImportJobQuery, Base.ImportJobQueryVariables>;
export function useImportJobQuery(options?: UseImportJobQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportJobQuery, Base.ImportJobQueryVariables>(Base.ImportJobDocument, options as any);
}
export type UseImportJobLazyQueryOptions = LazyQueryOpts<Base.ImportJobQueryVariables>;
export function useImportJobLazyQuery(options?: UseImportJobLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportJobQuery, Base.ImportJobQueryVariables>(Base.ImportJobDocument, options as any);
}


// AddImportJob
export type UseAddImportJobMutationOptions = MutationOpts<Base.AddImportJobMutation, Base.AddImportJobMutationVariables>;
export function useAddImportJobMutation(options?: UseAddImportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddImportJobMutation, Base.AddImportJobMutationVariables>(Base.AddImportJobDocument, options as any);
}


// UpdateImportJob
export type UseUpdateImportJobMutationOptions = MutationOpts<Base.UpdateImportJobMutation, Base.UpdateImportJobMutationVariables>;
export function useUpdateImportJobMutation(options?: UseUpdateImportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateImportJobMutation, Base.UpdateImportJobMutationVariables>(Base.UpdateImportJobDocument, options as any);
}


// DeleteImportJob
export type UseDeleteImportJobMutationOptions = MutationOpts<Base.DeleteImportJobMutation, Base.DeleteImportJobMutationVariables>;
export function useDeleteImportJobMutation(options?: UseDeleteImportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteImportJobMutation, Base.DeleteImportJobMutationVariables>(Base.DeleteImportJobDocument, options as any);
}


// StartImportJob
export type UseStartImportJobMutationOptions = MutationOpts<Base.StartImportJobMutation, Base.StartImportJobMutationVariables>;
export function useStartImportJobMutation(options?: UseStartImportJobMutationOptions | AnyMutationOpts) {
  return useMutation<Base.StartImportJobMutation, Base.StartImportJobMutationVariables>(Base.StartImportJobDocument, options as any);
}


// ImportJobProperty
export type UseImportJobPropertyQueryOptions = QueryOpts<Base.ImportJobPropertyQuery, Base.ImportJobPropertyQueryVariables>;
export function useImportJobPropertyQuery(options?: UseImportJobPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportJobPropertyQuery, Base.ImportJobPropertyQueryVariables>(Base.ImportJobPropertyDocument, options as any);
}
export type UseImportJobPropertyLazyQueryOptions = LazyQueryOpts<Base.ImportJobPropertyQueryVariables>;
export function useImportJobPropertyLazyQuery(options?: UseImportJobPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportJobPropertyQuery, Base.ImportJobPropertyQueryVariables>(Base.ImportJobPropertyDocument, options as any);
}


// AddImportJobProperty
export type UseAddImportJobPropertyMutationOptions = MutationOpts<Base.AddImportJobPropertyMutation, Base.AddImportJobPropertyMutationVariables>;
export function useAddImportJobPropertyMutation(options?: UseAddImportJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddImportJobPropertyMutation, Base.AddImportJobPropertyMutationVariables>(Base.AddImportJobPropertyDocument, options as any);
}


// UpdateImportJobProperty
export type UseUpdateImportJobPropertyMutationOptions = MutationOpts<Base.UpdateImportJobPropertyMutation, Base.UpdateImportJobPropertyMutationVariables>;
export function useUpdateImportJobPropertyMutation(options?: UseUpdateImportJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateImportJobPropertyMutation, Base.UpdateImportJobPropertyMutationVariables>(Base.UpdateImportJobPropertyDocument, options as any);
}


// DeleteImportJobProperty
export type UseDeleteImportJobPropertyMutationOptions = MutationOpts<Base.DeleteImportJobPropertyMutation, Base.DeleteImportJobPropertyMutationVariables>;
export function useDeleteImportJobPropertyMutation(options?: UseDeleteImportJobPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteImportJobPropertyMutation, Base.DeleteImportJobPropertyMutationVariables>(Base.DeleteImportJobPropertyDocument, options as any);
}


// ImportProcesses
export type UseImportProcessesQueryOptions = QueryOpts<Base.ImportProcessesQuery, Base.ImportProcessesQueryVariables>;
export function useImportProcessesQuery(options?: UseImportProcessesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportProcessesQuery, Base.ImportProcessesQueryVariables>(Base.ImportProcessesDocument, options as any);
}
export type UseImportProcessesLazyQueryOptions = LazyQueryOpts<Base.ImportProcessesQueryVariables>;
export function useImportProcessesLazyQuery(options?: UseImportProcessesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportProcessesQuery, Base.ImportProcessesQueryVariables>(Base.ImportProcessesDocument, options as any);
}


// ImportProcessById
export type UseImportProcessByIdQueryOptions = QueryOpts<Base.ImportProcessByIdQuery, Base.ImportProcessByIdQueryVariables>;
export function useImportProcessByIdQuery(options?: UseImportProcessByIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportProcessByIdQuery, Base.ImportProcessByIdQueryVariables>(Base.ImportProcessByIdDocument, options as any);
}
export type UseImportProcessByIdLazyQueryOptions = LazyQueryOpts<Base.ImportProcessByIdQueryVariables>;
export function useImportProcessByIdLazyQuery(options?: UseImportProcessByIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportProcessByIdQuery, Base.ImportProcessByIdQueryVariables>(Base.ImportProcessByIdDocument, options as any);
}


// ImportProcessWithIssues
export type UseImportProcessWithIssuesQueryOptions = QueryOpts<Base.ImportProcessWithIssuesQuery, Base.ImportProcessWithIssuesQueryVariables>;
export function useImportProcessWithIssuesQuery(options?: UseImportProcessWithIssuesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ImportProcessWithIssuesQuery, Base.ImportProcessWithIssuesQueryVariables>(Base.ImportProcessWithIssuesDocument, options as any);
}
export type UseImportProcessWithIssuesLazyQueryOptions = LazyQueryOpts<Base.ImportProcessWithIssuesQueryVariables>;
export function useImportProcessWithIssuesLazyQuery(options?: UseImportProcessWithIssuesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ImportProcessWithIssuesQuery, Base.ImportProcessWithIssuesQueryVariables>(Base.ImportProcessWithIssuesDocument, options as any);
}


// GetForwarderFilters
export type UseGetForwarderFiltersQueryOptions = QueryOpts<Base.GetForwarderFiltersQuery, Base.GetForwarderFiltersQueryVariables>;
export function useGetForwarderFiltersQuery(options?: UseGetForwarderFiltersQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetForwarderFiltersQuery, Base.GetForwarderFiltersQueryVariables>(Base.GetForwarderFiltersDocument, options as any);
}
export type UseGetForwarderFiltersLazyQueryOptions = LazyQueryOpts<Base.GetForwarderFiltersQueryVariables>;
export function useGetForwarderFiltersLazyQuery(options?: UseGetForwarderFiltersLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetForwarderFiltersQuery, Base.GetForwarderFiltersQueryVariables>(Base.GetForwarderFiltersDocument, options as any);
}


// AddForwarderFilters
export type UseAddForwarderFiltersMutationOptions = MutationOpts<Base.AddForwarderFiltersMutation, Base.AddForwarderFiltersMutationVariables>;
export function useAddForwarderFiltersMutation(options?: UseAddForwarderFiltersMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddForwarderFiltersMutation, Base.AddForwarderFiltersMutationVariables>(Base.AddForwarderFiltersDocument, options as any);
}


// UpdateForwarderFilters
export type UseUpdateForwarderFiltersMutationOptions = MutationOpts<Base.UpdateForwarderFiltersMutation, Base.UpdateForwarderFiltersMutationVariables>;
export function useUpdateForwarderFiltersMutation(options?: UseUpdateForwarderFiltersMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateForwarderFiltersMutation, Base.UpdateForwarderFiltersMutationVariables>(Base.UpdateForwarderFiltersDocument, options as any);
}


// DeleteForwarderFilters
export type UseDeleteForwarderFiltersMutationOptions = MutationOpts<Base.DeleteForwarderFiltersMutation, Base.DeleteForwarderFiltersMutationVariables>;
export function useDeleteForwarderFiltersMutation(options?: UseDeleteForwarderFiltersMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteForwarderFiltersMutation, Base.DeleteForwarderFiltersMutationVariables>(Base.DeleteForwarderFiltersDocument, options as any);
}


// ForwarderProperties
export type UseForwarderPropertiesQueryOptions = QueryOpts<Base.ForwarderPropertiesQuery, Base.ForwarderPropertiesQueryVariables>;
export function useForwarderPropertiesQuery(options?: UseForwarderPropertiesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ForwarderPropertiesQuery, Base.ForwarderPropertiesQueryVariables>(Base.ForwarderPropertiesDocument, options as any);
}
export type UseForwarderPropertiesLazyQueryOptions = LazyQueryOpts<Base.ForwarderPropertiesQueryVariables>;
export function useForwarderPropertiesLazyQuery(options?: UseForwarderPropertiesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ForwarderPropertiesQuery, Base.ForwarderPropertiesQueryVariables>(Base.ForwarderPropertiesDocument, options as any);
}


// AddForwarderProperty
export type UseAddForwarderPropertyMutationOptions = MutationOpts<Base.AddForwarderPropertyMutation, Base.AddForwarderPropertyMutationVariables>;
export function useAddForwarderPropertyMutation(options?: UseAddForwarderPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddForwarderPropertyMutation, Base.AddForwarderPropertyMutationVariables>(Base.AddForwarderPropertyDocument, options as any);
}


// UpdateForwarderProperty
export type UseUpdateForwarderPropertyMutationOptions = MutationOpts<Base.UpdateForwarderPropertyMutation, Base.UpdateForwarderPropertyMutationVariables>;
export function useUpdateForwarderPropertyMutation(options?: UseUpdateForwarderPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateForwarderPropertyMutation, Base.UpdateForwarderPropertyMutationVariables>(Base.UpdateForwarderPropertyDocument, options as any);
}


// DeleteForwarderProperty
export type UseDeleteForwarderPropertyMutationOptions = MutationOpts<Base.DeleteForwarderPropertyMutation, Base.DeleteForwarderPropertyMutationVariables>;
export function useDeleteForwarderPropertyMutation(options?: UseDeleteForwarderPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteForwarderPropertyMutation, Base.DeleteForwarderPropertyMutationVariables>(Base.DeleteForwarderPropertyDocument, options as any);
}


// GetForwardersOnNode
export type UseGetForwardersOnNodeQueryOptions = QueryOpts<Base.GetForwardersOnNodeQuery, Base.GetForwardersOnNodeQueryVariables>;
export function useGetForwardersOnNodeQuery(options?: UseGetForwardersOnNodeQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetForwardersOnNodeQuery, Base.GetForwardersOnNodeQueryVariables>(Base.GetForwardersOnNodeDocument, options as any);
}
export type UseGetForwardersOnNodeLazyQueryOptions = LazyQueryOpts<Base.GetForwardersOnNodeQueryVariables>;
export function useGetForwardersOnNodeLazyQuery(options?: UseGetForwardersOnNodeLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetForwardersOnNodeQuery, Base.GetForwardersOnNodeQueryVariables>(Base.GetForwardersOnNodeDocument, options as any);
}


// ForwardersOnNodeOverview
export type UseForwardersOnNodeOverviewQueryOptions = QueryOpts<Base.ForwardersOnNodeOverviewQuery, Base.ForwardersOnNodeOverviewQueryVariables>;
export function useForwardersOnNodeOverviewQuery(options?: UseForwardersOnNodeOverviewQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ForwardersOnNodeOverviewQuery, Base.ForwardersOnNodeOverviewQueryVariables>(Base.ForwardersOnNodeOverviewDocument, options as any);
}
export type UseForwardersOnNodeOverviewLazyQueryOptions = LazyQueryOpts<Base.ForwardersOnNodeOverviewQueryVariables>;
export function useForwardersOnNodeOverviewLazyQuery(options?: UseForwardersOnNodeOverviewLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ForwardersOnNodeOverviewQuery, Base.ForwardersOnNodeOverviewQueryVariables>(Base.ForwardersOnNodeOverviewDocument, options as any);
}


// ForwardingsDailyAggregate
export type UseForwardingsDailyAggregateQueryOptions = QueryOpts<Base.ForwardingsDailyAggregateQuery, Base.ForwardingsDailyAggregateQueryVariables>;
export function useForwardingsDailyAggregateQuery(options?: UseForwardingsDailyAggregateQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ForwardingsDailyAggregateQuery, Base.ForwardingsDailyAggregateQueryVariables>(Base.ForwardingsDailyAggregateDocument, options as any);
}
export type UseForwardingsDailyAggregateLazyQueryOptions = LazyQueryOpts<Base.ForwardingsDailyAggregateQueryVariables>;
export function useForwardingsDailyAggregateLazyQuery(options?: UseForwardingsDailyAggregateLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ForwardingsDailyAggregateQuery, Base.ForwardingsDailyAggregateQueryVariables>(Base.ForwardingsDailyAggregateDocument, options as any);
}


// ForwardingsDailyAggregateFailures
export type UseForwardingsDailyAggregateFailuresQueryOptions = QueryOpts<Base.ForwardingsDailyAggregateFailuresQuery, Base.ForwardingsDailyAggregateFailuresQueryVariables>;
export function useForwardingsDailyAggregateFailuresQuery(options?: UseForwardingsDailyAggregateFailuresQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ForwardingsDailyAggregateFailuresQuery, Base.ForwardingsDailyAggregateFailuresQueryVariables>(Base.ForwardingsDailyAggregateFailuresDocument, options as any);
}
export type UseForwardingsDailyAggregateFailuresLazyQueryOptions = LazyQueryOpts<Base.ForwardingsDailyAggregateFailuresQueryVariables>;
export function useForwardingsDailyAggregateFailuresLazyQuery(options?: UseForwardingsDailyAggregateFailuresLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ForwardingsDailyAggregateFailuresQuery, Base.ForwardingsDailyAggregateFailuresQueryVariables>(Base.ForwardingsDailyAggregateFailuresDocument, options as any);
}


// ForwardingFailureLogs
export type UseForwardingFailureLogsQueryOptions = QueryOpts<Base.ForwardingFailureLogsQuery, Base.ForwardingFailureLogsQueryVariables>;
export function useForwardingFailureLogsQuery(options?: UseForwardingFailureLogsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ForwardingFailureLogsQuery, Base.ForwardingFailureLogsQueryVariables>(Base.ForwardingFailureLogsDocument, options as any);
}
export type UseForwardingFailureLogsLazyQueryOptions = LazyQueryOpts<Base.ForwardingFailureLogsQueryVariables>;
export function useForwardingFailureLogsLazyQuery(options?: UseForwardingFailureLogsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ForwardingFailureLogsQuery, Base.ForwardingFailureLogsQueryVariables>(Base.ForwardingFailureLogsDocument, options as any);
}


// AddForwarder
export type UseAddForwarderMutationOptions = MutationOpts<Base.AddForwarderMutation, Base.AddForwarderMutationVariables>;
export function useAddForwarderMutation(options?: UseAddForwarderMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddForwarderMutation, Base.AddForwarderMutationVariables>(Base.AddForwarderDocument, options as any);
}


// UpdateForwarder
export type UseUpdateForwarderMutationOptions = MutationOpts<Base.UpdateForwarderMutation, Base.UpdateForwarderMutationVariables>;
export function useUpdateForwarderMutation(options?: UseUpdateForwarderMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateForwarderMutation, Base.UpdateForwarderMutationVariables>(Base.UpdateForwarderDocument, options as any);
}


// DeleteForwarder
export type UseDeleteForwarderMutationOptions = MutationOpts<Base.DeleteForwarderMutation, Base.DeleteForwarderMutationVariables>;
export function useDeleteForwarderMutation(options?: UseDeleteForwarderMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteForwarderMutation, Base.DeleteForwarderMutationVariables>(Base.DeleteForwarderDocument, options as any);
}


// ServerActions
export type UseServerActionsQueryOptions = QueryOpts<Base.ServerActionsQuery, Base.ServerActionsQueryVariables>;
export function useServerActionsQuery(options?: UseServerActionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ServerActionsQuery, Base.ServerActionsQueryVariables>(Base.ServerActionsDocument, options as any);
}
export type UseServerActionsLazyQueryOptions = LazyQueryOpts<Base.ServerActionsQueryVariables>;
export function useServerActionsLazyQuery(options?: UseServerActionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ServerActionsQuery, Base.ServerActionsQueryVariables>(Base.ServerActionsDocument, options as any);
}


// ServerActionDashboard
export type UseServerActionDashboardQueryOptions = QueryOpts<Base.ServerActionDashboardQuery, Base.ServerActionDashboardQueryVariables>;
export function useServerActionDashboardQuery(options?: UseServerActionDashboardQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ServerActionDashboardQuery, Base.ServerActionDashboardQueryVariables>(Base.ServerActionDashboardDocument, options as any);
}
export type UseServerActionDashboardLazyQueryOptions = LazyQueryOpts<Base.ServerActionDashboardQueryVariables>;
export function useServerActionDashboardLazyQuery(options?: UseServerActionDashboardLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ServerActionDashboardQuery, Base.ServerActionDashboardQueryVariables>(Base.ServerActionDashboardDocument, options as any);
}


// ServerActionsOnNodeWithChildren
export type UseServerActionsOnNodeWithChildrenQueryOptions = QueryOpts<Base.ServerActionsOnNodeWithChildrenQuery, Base.ServerActionsOnNodeWithChildrenQueryVariables>;
export function useServerActionsOnNodeWithChildrenQuery(options?: UseServerActionsOnNodeWithChildrenQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ServerActionsOnNodeWithChildrenQuery, Base.ServerActionsOnNodeWithChildrenQueryVariables>(Base.ServerActionsOnNodeWithChildrenDocument, options as any);
}
export type UseServerActionsOnNodeWithChildrenLazyQueryOptions = LazyQueryOpts<Base.ServerActionsOnNodeWithChildrenQueryVariables>;
export function useServerActionsOnNodeWithChildrenLazyQuery(options?: UseServerActionsOnNodeWithChildrenLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ServerActionsOnNodeWithChildrenQuery, Base.ServerActionsOnNodeWithChildrenQueryVariables>(Base.ServerActionsOnNodeWithChildrenDocument, options as any);
}


// ServerAction
export type UseServerActionQueryOptions = QueryOpts<Base.ServerActionQuery, Base.ServerActionQueryVariables>;
export function useServerActionQuery(options?: UseServerActionQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ServerActionQuery, Base.ServerActionQueryVariables>(Base.ServerActionDocument, options as any);
}
export type UseServerActionLazyQueryOptions = LazyQueryOpts<Base.ServerActionQueryVariables>;
export function useServerActionLazyQuery(options?: UseServerActionLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ServerActionQuery, Base.ServerActionQueryVariables>(Base.ServerActionDocument, options as any);
}


// ServerActionProperty
export type UseServerActionPropertyQueryOptions = QueryOpts<Base.ServerActionPropertyQuery, Base.ServerActionPropertyQueryVariables>;
export function useServerActionPropertyQuery(options?: UseServerActionPropertyQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ServerActionPropertyQuery, Base.ServerActionPropertyQueryVariables>(Base.ServerActionPropertyDocument, options as any);
}
export type UseServerActionPropertyLazyQueryOptions = LazyQueryOpts<Base.ServerActionPropertyQueryVariables>;
export function useServerActionPropertyLazyQuery(options?: UseServerActionPropertyLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ServerActionPropertyQuery, Base.ServerActionPropertyQueryVariables>(Base.ServerActionPropertyDocument, options as any);
}


// ServerActionFailureLogs
export type UseServerActionFailureLogsQueryOptions = QueryOpts<Base.ServerActionFailureLogsQuery, Base.ServerActionFailureLogsQueryVariables>;
export function useServerActionFailureLogsQuery(options?: UseServerActionFailureLogsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ServerActionFailureLogsQuery, Base.ServerActionFailureLogsQueryVariables>(Base.ServerActionFailureLogsDocument, options as any);
}
export type UseServerActionFailureLogsLazyQueryOptions = LazyQueryOpts<Base.ServerActionFailureLogsQueryVariables>;
export function useServerActionFailureLogsLazyQuery(options?: UseServerActionFailureLogsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ServerActionFailureLogsQuery, Base.ServerActionFailureLogsQueryVariables>(Base.ServerActionFailureLogsDocument, options as any);
}


// AddServerAction
export type UseAddServerActionMutationOptions = MutationOpts<Base.AddServerActionMutation, Base.AddServerActionMutationVariables>;
export function useAddServerActionMutation(options?: UseAddServerActionMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddServerActionMutation, Base.AddServerActionMutationVariables>(Base.AddServerActionDocument, options as any);
}


// AddServerActionProperty
export type UseAddServerActionPropertyMutationOptions = MutationOpts<Base.AddServerActionPropertyMutation, Base.AddServerActionPropertyMutationVariables>;
export function useAddServerActionPropertyMutation(options?: UseAddServerActionPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddServerActionPropertyMutation, Base.AddServerActionPropertyMutationVariables>(Base.AddServerActionPropertyDocument, options as any);
}


// UpdateServerActionProperty
export type UseUpdateServerActionPropertyMutationOptions = MutationOpts<Base.UpdateServerActionPropertyMutation, Base.UpdateServerActionPropertyMutationVariables>;
export function useUpdateServerActionPropertyMutation(options?: UseUpdateServerActionPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateServerActionPropertyMutation, Base.UpdateServerActionPropertyMutationVariables>(Base.UpdateServerActionPropertyDocument, options as any);
}


// UpdateServerAction
export type UseUpdateServerActionMutationOptions = MutationOpts<Base.UpdateServerActionMutation, Base.UpdateServerActionMutationVariables>;
export function useUpdateServerActionMutation(options?: UseUpdateServerActionMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateServerActionMutation, Base.UpdateServerActionMutationVariables>(Base.UpdateServerActionDocument, options as any);
}


// DeleteServerAction
export type UseDeleteServerActionMutationOptions = MutationOpts<Base.DeleteServerActionMutation, Base.DeleteServerActionMutationVariables>;
export function useDeleteServerActionMutation(options?: UseDeleteServerActionMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteServerActionMutation, Base.DeleteServerActionMutationVariables>(Base.DeleteServerActionDocument, options as any);
}


// DeleteServerActionProperty
export type UseDeleteServerActionPropertyMutationOptions = MutationOpts<Base.DeleteServerActionPropertyMutation, Base.DeleteServerActionPropertyMutationVariables>;
export function useDeleteServerActionPropertyMutation(options?: UseDeleteServerActionPropertyMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteServerActionPropertyMutation, Base.DeleteServerActionPropertyMutationVariables>(Base.DeleteServerActionPropertyDocument, options as any);
}


// PackageUploadUrl
export type UsePackageUploadUrlQueryOptions = QueryOpts<Base.PackageUploadUrlQuery, Base.PackageUploadUrlQueryVariables>;
export function usePackageUploadUrlQuery(options?: UsePackageUploadUrlQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageUploadUrlQuery, Base.PackageUploadUrlQueryVariables>(Base.PackageUploadUrlDocument, options as any);
}
export type UsePackageUploadUrlLazyQueryOptions = LazyQueryOpts<Base.PackageUploadUrlQueryVariables>;
export function usePackageUploadUrlLazyQuery(options?: UsePackageUploadUrlLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageUploadUrlQuery, Base.PackageUploadUrlQueryVariables>(Base.PackageUploadUrlDocument, options as any);
}


// PackageFamilies
export type UsePackageFamiliesQueryOptions = QueryOpts<Base.PackageFamiliesQuery, Base.PackageFamiliesQueryVariables>;
export function usePackageFamiliesQuery(options?: UsePackageFamiliesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageFamiliesQuery, Base.PackageFamiliesQueryVariables>(Base.PackageFamiliesDocument, options as any);
}
export type UsePackageFamiliesLazyQueryOptions = LazyQueryOpts<Base.PackageFamiliesQueryVariables>;
export function usePackageFamiliesLazyQuery(options?: UsePackageFamiliesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageFamiliesQuery, Base.PackageFamiliesQueryVariables>(Base.PackageFamiliesDocument, options as any);
}


// PackageFamiliesByNodeId
export type UsePackageFamiliesByNodeIdQueryOptions = QueryOpts<Base.PackageFamiliesByNodeIdQuery, Base.PackageFamiliesByNodeIdQueryVariables>;
export function usePackageFamiliesByNodeIdQuery(options?: UsePackageFamiliesByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageFamiliesByNodeIdQuery, Base.PackageFamiliesByNodeIdQueryVariables>(Base.PackageFamiliesByNodeIdDocument, options as any);
}
export type UsePackageFamiliesByNodeIdLazyQueryOptions = LazyQueryOpts<Base.PackageFamiliesByNodeIdQueryVariables>;
export function usePackageFamiliesByNodeIdLazyQuery(options?: UsePackageFamiliesByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageFamiliesByNodeIdQuery, Base.PackageFamiliesByNodeIdQueryVariables>(Base.PackageFamiliesByNodeIdDocument, options as any);
}


// FirmwareFromStore
export type UseFirmwareFromStoreQueryOptions = QueryOpts<Base.FirmwareFromStoreQuery, Base.FirmwareFromStoreQueryVariables>;
export function useFirmwareFromStoreQuery(options?: UseFirmwareFromStoreQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FirmwareFromStoreQuery, Base.FirmwareFromStoreQueryVariables>(Base.FirmwareFromStoreDocument, options as any);
}
export type UseFirmwareFromStoreLazyQueryOptions = LazyQueryOpts<Base.FirmwareFromStoreQueryVariables>;
export function useFirmwareFromStoreLazyQuery(options?: UseFirmwareFromStoreLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FirmwareFromStoreQuery, Base.FirmwareFromStoreQueryVariables>(Base.FirmwareFromStoreDocument, options as any);
}


// AddFirmwareFromStore
export type UseAddFirmwareFromStoreMutationOptions = MutationOpts<Base.AddFirmwareFromStoreMutation, Base.AddFirmwareFromStoreMutationVariables>;
export function useAddFirmwareFromStoreMutation(options?: UseAddFirmwareFromStoreMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddFirmwareFromStoreMutation, Base.AddFirmwareFromStoreMutationVariables>(Base.AddFirmwareFromStoreDocument, options as any);
}


// UpdateFirmware
export type UseUpdateFirmwareMutationOptions = MutationOpts<Base.UpdateFirmwareMutation, Base.UpdateFirmwareMutationVariables>;
export function useUpdateFirmwareMutation(options?: UseUpdateFirmwareMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateFirmwareMutation, Base.UpdateFirmwareMutationVariables>(Base.UpdateFirmwareDocument, options as any);
}


// PackageVersions
export type UsePackageVersionsQueryOptions = QueryOpts<Base.PackageVersionsQuery, Base.PackageVersionsQueryVariables>;
export function usePackageVersionsQuery(options?: UsePackageVersionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageVersionsQuery, Base.PackageVersionsQueryVariables>(Base.PackageVersionsDocument, options as any);
}
export type UsePackageVersionsLazyQueryOptions = LazyQueryOpts<Base.PackageVersionsQueryVariables>;
export function usePackageVersionsLazyQuery(options?: UsePackageVersionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageVersionsQuery, Base.PackageVersionsQueryVariables>(Base.PackageVersionsDocument, options as any);
}


// AssetUploadUrl
export type UseAssetUploadUrlQueryOptions = QueryOpts<Base.AssetUploadUrlQuery, Base.AssetUploadUrlQueryVariables>;
export function useAssetUploadUrlQuery(options?: UseAssetUploadUrlQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AssetUploadUrlQuery, Base.AssetUploadUrlQueryVariables>(Base.AssetUploadUrlDocument, options as any);
}
export type UseAssetUploadUrlLazyQueryOptions = LazyQueryOpts<Base.AssetUploadUrlQueryVariables>;
export function useAssetUploadUrlLazyQuery(options?: UseAssetUploadUrlLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AssetUploadUrlQuery, Base.AssetUploadUrlQueryVariables>(Base.AssetUploadUrlDocument, options as any);
}


// Asset
export type UseAssetQueryOptions = QueryOpts<Base.AssetQuery, Base.AssetQueryVariables>;
export function useAssetQuery(options?: UseAssetQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AssetQuery, Base.AssetQueryVariables>(Base.AssetDocument, options as any);
}
export type UseAssetLazyQueryOptions = LazyQueryOpts<Base.AssetQueryVariables>;
export function useAssetLazyQuery(options?: UseAssetLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AssetQuery, Base.AssetQueryVariables>(Base.AssetDocument, options as any);
}


// Assets
export type UseAssetsQueryOptions = QueryOpts<Base.AssetsQuery, Base.AssetsQueryVariables>;
export function useAssetsQuery(options?: UseAssetsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AssetsQuery, Base.AssetsQueryVariables>(Base.AssetsDocument, options as any);
}
export type UseAssetsLazyQueryOptions = LazyQueryOpts<Base.AssetsQueryVariables>;
export function useAssetsLazyQuery(options?: UseAssetsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AssetsQuery, Base.AssetsQueryVariables>(Base.AssetsDocument, options as any);
}


// AssetsCompatible
export type UseAssetsCompatibleQueryOptions = QueryOpts<Base.AssetsCompatibleQuery, Base.AssetsCompatibleQueryVariables>;
export function useAssetsCompatibleQuery(options?: UseAssetsCompatibleQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AssetsCompatibleQuery, Base.AssetsCompatibleQueryVariables>(Base.AssetsCompatibleDocument, options as any);
}
export type UseAssetsCompatibleLazyQueryOptions = LazyQueryOpts<Base.AssetsCompatibleQueryVariables>;
export function useAssetsCompatibleLazyQuery(options?: UseAssetsCompatibleLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AssetsCompatibleQuery, Base.AssetsCompatibleQueryVariables>(Base.AssetsCompatibleDocument, options as any);
}


// UpdateAsset
export type UseUpdateAssetMutationOptions = MutationOpts<Base.UpdateAssetMutation, Base.UpdateAssetMutationVariables>;
export function useUpdateAssetMutation(options?: UseUpdateAssetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateAssetMutation, Base.UpdateAssetMutationVariables>(Base.UpdateAssetDocument, options as any);
}


// UpdateConfigAsset
export type UseUpdateConfigAssetMutationOptions = MutationOpts<Base.UpdateConfigAssetMutation, Base.UpdateConfigAssetMutationVariables>;
export function useUpdateConfigAssetMutation(options?: UseUpdateConfigAssetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateConfigAssetMutation, Base.UpdateConfigAssetMutationVariables>(Base.UpdateConfigAssetDocument, options as any);
}


// CopySourceAsset
export type UseCopySourceAssetMutationOptions = MutationOpts<Base.CopySourceAssetMutation, Base.CopySourceAssetMutationVariables>;
export function useCopySourceAssetMutation(options?: UseCopySourceAssetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.CopySourceAssetMutation, Base.CopySourceAssetMutationVariables>(Base.CopySourceAssetDocument, options as any);
}


// DeleteAsset
export type UseDeleteAssetMutationOptions = MutationOpts<Base.DeleteAssetMutation, Base.DeleteAssetMutationVariables>;
export function useDeleteAssetMutation(options?: UseDeleteAssetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteAssetMutation, Base.DeleteAssetMutationVariables>(Base.DeleteAssetDocument, options as any);
}


// DeleteConfigAsset
export type UseDeleteConfigAssetMutationOptions = MutationOpts<Base.DeleteConfigAssetMutation, Base.DeleteConfigAssetMutationVariables>;
export function useDeleteConfigAssetMutation(options?: UseDeleteConfigAssetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteConfigAssetMutation, Base.DeleteConfigAssetMutationVariables>(Base.DeleteConfigAssetDocument, options as any);
}


// UploadAnAsset
export type UseUploadAnAssetMutationOptions = MutationOpts<Base.UploadAnAssetMutation, Base.UploadAnAssetMutationVariables>;
export function useUploadAnAssetMutation(options?: UseUploadAnAssetMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UploadAnAssetMutation, Base.UploadAnAssetMutationVariables>(Base.UploadAnAssetDocument, options as any);
}


// LinkSourceAssetToDeviceOrNode
export type UseLinkSourceAssetToDeviceOrNodeMutationOptions = MutationOpts<Base.LinkSourceAssetToDeviceOrNodeMutation, Base.LinkSourceAssetToDeviceOrNodeMutationVariables>;
export function useLinkSourceAssetToDeviceOrNodeMutation(options?: UseLinkSourceAssetToDeviceOrNodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.LinkSourceAssetToDeviceOrNodeMutation, Base.LinkSourceAssetToDeviceOrNodeMutationVariables>(Base.LinkSourceAssetToDeviceOrNodeDocument, options as any);
}


// HomeDeviceMetrics
export type UseHomeDeviceMetricsQueryOptions = QueryOpts<Base.HomeDeviceMetricsQuery, Base.HomeDeviceMetricsQueryVariables>;
export function useHomeDeviceMetricsQuery(options?: UseHomeDeviceMetricsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.HomeDeviceMetricsQuery, Base.HomeDeviceMetricsQueryVariables>(Base.HomeDeviceMetricsDocument, options as any);
}
export type UseHomeDeviceMetricsLazyQueryOptions = LazyQueryOpts<Base.HomeDeviceMetricsQueryVariables>;
export function useHomeDeviceMetricsLazyQuery(options?: UseHomeDeviceMetricsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.HomeDeviceMetricsQuery, Base.HomeDeviceMetricsQueryVariables>(Base.HomeDeviceMetricsDocument, options as any);
}


// InheritedConfigurationSummary
export type UseInheritedConfigurationSummaryQueryOptions = QueryOpts<Base.InheritedConfigurationSummaryQuery, Base.InheritedConfigurationSummaryQueryVariables>;
export function useInheritedConfigurationSummaryQuery(options?: UseInheritedConfigurationSummaryQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedConfigurationSummaryQuery, Base.InheritedConfigurationSummaryQueryVariables>(Base.InheritedConfigurationSummaryDocument, options as any);
}
export type UseInheritedConfigurationSummaryLazyQueryOptions = LazyQueryOpts<Base.InheritedConfigurationSummaryQueryVariables>;
export function useInheritedConfigurationSummaryLazyQuery(options?: UseInheritedConfigurationSummaryLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedConfigurationSummaryQuery, Base.InheritedConfigurationSummaryQueryVariables>(Base.InheritedConfigurationSummaryDocument, options as any);
}


// InheritedFilesSummary
export type UseInheritedFilesSummaryQueryOptions = QueryOpts<Base.InheritedFilesSummaryQuery, Base.InheritedFilesSummaryQueryVariables>;
export function useInheritedFilesSummaryQuery(options?: UseInheritedFilesSummaryQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedFilesSummaryQuery, Base.InheritedFilesSummaryQueryVariables>(Base.InheritedFilesSummaryDocument, options as any);
}
export type UseInheritedFilesSummaryLazyQueryOptions = LazyQueryOpts<Base.InheritedFilesSummaryQueryVariables>;
export function useInheritedFilesSummaryLazyQuery(options?: UseInheritedFilesSummaryLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedFilesSummaryQuery, Base.InheritedFilesSummaryQueryVariables>(Base.InheritedFilesSummaryDocument, options as any);
}


// InheritedFirmwareSummary
export type UseInheritedFirmwareSummaryQueryOptions = QueryOpts<Base.InheritedFirmwareSummaryQuery, Base.InheritedFirmwareSummaryQueryVariables>;
export function useInheritedFirmwareSummaryQuery(options?: UseInheritedFirmwareSummaryQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedFirmwareSummaryQuery, Base.InheritedFirmwareSummaryQueryVariables>(Base.InheritedFirmwareSummaryDocument, options as any);
}
export type UseInheritedFirmwareSummaryLazyQueryOptions = LazyQueryOpts<Base.InheritedFirmwareSummaryQueryVariables>;
export function useInheritedFirmwareSummaryLazyQuery(options?: UseInheritedFirmwareSummaryLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedFirmwareSummaryQuery, Base.InheritedFirmwareSummaryQueryVariables>(Base.InheritedFirmwareSummaryDocument, options as any);
}


// InheritedApplicationSummary
export type UseInheritedApplicationSummaryQueryOptions = QueryOpts<Base.InheritedApplicationSummaryQuery, Base.InheritedApplicationSummaryQueryVariables>;
export function useInheritedApplicationSummaryQuery(options?: UseInheritedApplicationSummaryQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedApplicationSummaryQuery, Base.InheritedApplicationSummaryQueryVariables>(Base.InheritedApplicationSummaryDocument, options as any);
}
export type UseInheritedApplicationSummaryLazyQueryOptions = LazyQueryOpts<Base.InheritedApplicationSummaryQueryVariables>;
export function useInheritedApplicationSummaryLazyQuery(options?: UseInheritedApplicationSummaryLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedApplicationSummaryQuery, Base.InheritedApplicationSummaryQueryVariables>(Base.InheritedApplicationSummaryDocument, options as any);
}


// DeviceOverview
export type UseDeviceOverviewQueryOptions = QueryOpts<Base.DeviceOverviewQuery, Base.DeviceOverviewQueryVariables>;
export function useDeviceOverviewQuery(options?: UseDeviceOverviewQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceOverviewQuery, Base.DeviceOverviewQueryVariables>(Base.DeviceOverviewDocument, options as any);
}
export type UseDeviceOverviewLazyQueryOptions = LazyQueryOpts<Base.DeviceOverviewQueryVariables>;
export function useDeviceOverviewLazyQuery(options?: UseDeviceOverviewLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceOverviewQuery, Base.DeviceOverviewQueryVariables>(Base.DeviceOverviewDocument, options as any);
}


// DevicesOnNode
export type UseDevicesOnNodeQueryOptions = QueryOpts<Base.DevicesOnNodeQuery, Base.DevicesOnNodeQueryVariables>;
export function useDevicesOnNodeQuery(options?: UseDevicesOnNodeQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DevicesOnNodeQuery, Base.DevicesOnNodeQueryVariables>(Base.DevicesOnNodeDocument, options as any);
}
export type UseDevicesOnNodeLazyQueryOptions = LazyQueryOpts<Base.DevicesOnNodeQueryVariables>;
export function useDevicesOnNodeLazyQuery(options?: UseDevicesOnNodeLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DevicesOnNodeQuery, Base.DevicesOnNodeQueryVariables>(Base.DevicesOnNodeDocument, options as any);
}


// Device
export type UseDeviceQueryOptions = QueryOpts<Base.DeviceQuery, Base.DeviceQueryVariables>;
export function useDeviceQuery(options?: UseDeviceQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceQuery, Base.DeviceQueryVariables>(Base.DeviceDocument, options as any);
}
export type UseDeviceLazyQueryOptions = LazyQueryOpts<Base.DeviceQueryVariables>;
export function useDeviceLazyQuery(options?: UseDeviceLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceQuery, Base.DeviceQueryVariables>(Base.DeviceDocument, options as any);
}


// MoveDevices
export type UseMoveDevicesMutationOptions = MutationOpts<Base.MoveDevicesMutation, Base.MoveDevicesMutationVariables>;
export function useMoveDevicesMutation(options?: UseMoveDevicesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.MoveDevicesMutation, Base.MoveDevicesMutationVariables>(Base.MoveDevicesDocument, options as any);
}


// MoveListOfDevices
export type UseMoveListOfDevicesMutationOptions = MutationOpts<Base.MoveListOfDevicesMutation, Base.MoveListOfDevicesMutationVariables>;
export function useMoveListOfDevicesMutation(options?: UseMoveListOfDevicesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.MoveListOfDevicesMutation, Base.MoveListOfDevicesMutationVariables>(Base.MoveListOfDevicesDocument, options as any);
}


// QuickDeployDevices
export type UseQuickDeployDevicesMutationOptions = MutationOpts<Base.QuickDeployDevicesMutation, Base.QuickDeployDevicesMutationVariables>;
export function useQuickDeployDevicesMutation(options?: UseQuickDeployDevicesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.QuickDeployDevicesMutation, Base.QuickDeployDevicesMutationVariables>(Base.QuickDeployDevicesDocument, options as any);
}


// UpdateDevice
export type UseUpdateDeviceMutationOptions = MutationOpts<Base.UpdateDeviceMutation, Base.UpdateDeviceMutationVariables>;
export function useUpdateDeviceMutation(options?: UseUpdateDeviceMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateDeviceMutation, Base.UpdateDeviceMutationVariables>(Base.UpdateDeviceDocument, options as any);
}


// AssignDevices
export type UseAssignDevicesMutationOptions = MutationOpts<Base.AssignDevicesMutation, Base.AssignDevicesMutationVariables>;
export function useAssignDevicesMutation(options?: UseAssignDevicesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AssignDevicesMutation, Base.AssignDevicesMutationVariables>(Base.AssignDevicesDocument, options as any);
}


// DecomissionDevice
export type UseDecomissionDeviceMutationOptions = MutationOpts<Base.DecomissionDeviceMutation, Base.DecomissionDeviceMutationVariables>;
export function useDecomissionDeviceMutation(options?: UseDecomissionDeviceMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DecomissionDeviceMutation, Base.DecomissionDeviceMutationVariables>(Base.DecomissionDeviceDocument, options as any);
}


// UnassignDevices
export type UseUnassignDevicesMutationOptions = MutationOpts<Base.UnassignDevicesMutation, Base.UnassignDevicesMutationVariables>;
export function useUnassignDevicesMutation(options?: UseUnassignDevicesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UnassignDevicesMutation, Base.UnassignDevicesMutationVariables>(Base.UnassignDevicesDocument, options as any);
}


// NodeWithChildrenById
export type UseNodeWithChildrenByIdQueryOptions = QueryOpts<Base.NodeWithChildrenByIdQuery, Base.NodeWithChildrenByIdQueryVariables>;
export function useNodeWithChildrenByIdQuery(options?: UseNodeWithChildrenByIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodeWithChildrenByIdQuery, Base.NodeWithChildrenByIdQueryVariables>(Base.NodeWithChildrenByIdDocument, options as any);
}
export type UseNodeWithChildrenByIdLazyQueryOptions = LazyQueryOpts<Base.NodeWithChildrenByIdQueryVariables>;
export function useNodeWithChildrenByIdLazyQuery(options?: UseNodeWithChildrenByIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodeWithChildrenByIdQuery, Base.NodeWithChildrenByIdQueryVariables>(Base.NodeWithChildrenByIdDocument, options as any);
}


// AdditionalFields
export type UseAdditionalFieldsQueryOptions = QueryOpts<Base.AdditionalFieldsQuery, Base.AdditionalFieldsQueryVariables>;
export function useAdditionalFieldsQuery(options?: UseAdditionalFieldsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AdditionalFieldsQuery, Base.AdditionalFieldsQueryVariables>(Base.AdditionalFieldsDocument, options as any);
}
export type UseAdditionalFieldsLazyQueryOptions = LazyQueryOpts<Base.AdditionalFieldsQueryVariables>;
export function useAdditionalFieldsLazyQuery(options?: UseAdditionalFieldsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AdditionalFieldsQuery, Base.AdditionalFieldsQueryVariables>(Base.AdditionalFieldsDocument, options as any);
}


// AssetLinks
export type UseAssetLinksQueryOptions = QueryOpts<Base.AssetLinksQuery, Base.AssetLinksQueryVariables>;
export function useAssetLinksQuery(options?: UseAssetLinksQueryOptions | AnyQueryOpts) {
  return useQuery<Base.AssetLinksQuery, Base.AssetLinksQueryVariables>(Base.AssetLinksDocument, options as any);
}
export type UseAssetLinksLazyQueryOptions = LazyQueryOpts<Base.AssetLinksQueryVariables>;
export function useAssetLinksLazyQuery(options?: UseAssetLinksLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.AssetLinksQuery, Base.AssetLinksQueryVariables>(Base.AssetLinksDocument, options as any);
}


// AddAssetLink
export type UseAddAssetLinkMutationOptions = MutationOpts<Base.AddAssetLinkMutation, Base.AddAssetLinkMutationVariables>;
export function useAddAssetLinkMutation(options?: UseAddAssetLinkMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddAssetLinkMutation, Base.AddAssetLinkMutationVariables>(Base.AddAssetLinkDocument, options as any);
}


// UpdateAssetLink
export type UseUpdateAssetLinkMutationOptions = MutationOpts<Base.UpdateAssetLinkMutation, Base.UpdateAssetLinkMutationVariables>;
export function useUpdateAssetLinkMutation(options?: UseUpdateAssetLinkMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateAssetLinkMutation, Base.UpdateAssetLinkMutationVariables>(Base.UpdateAssetLinkDocument, options as any);
}


// DeleteAssetLink
export type UseDeleteAssetLinkMutationOptions = MutationOpts<Base.DeleteAssetLinkMutation, Base.DeleteAssetLinkMutationVariables>;
export function useDeleteAssetLinkMutation(options?: UseDeleteAssetLinkMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteAssetLinkMutation, Base.DeleteAssetLinkMutationVariables>(Base.DeleteAssetLinkDocument, options as any);
}


// Command_ReloadDevice
export type UseCommand_ReloadDeviceMutationOptions = MutationOpts<Base.Command_ReloadDeviceMutation, Base.Command_ReloadDeviceMutationVariables>;
export function useCommand_ReloadDeviceMutation(options?: UseCommand_ReloadDeviceMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_ReloadDeviceMutation, Base.Command_ReloadDeviceMutationVariables>(Base.Command_ReloadDeviceDocument, options as any);
}


// Command_RebootDevice
export type UseCommand_RebootDeviceMutationOptions = MutationOpts<Base.Command_RebootDeviceMutation, Base.Command_RebootDeviceMutationVariables>;
export function useCommand_RebootDeviceMutation(options?: UseCommand_RebootDeviceMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_RebootDeviceMutation, Base.Command_RebootDeviceMutationVariables>(Base.Command_RebootDeviceDocument, options as any);
}


// Command_RestartApp
export type UseCommand_RestartAppMutationOptions = MutationOpts<Base.Command_RestartAppMutation, Base.Command_RestartAppMutationVariables>;
export function useCommand_RestartAppMutation(options?: UseCommand_RestartAppMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_RestartAppMutation, Base.Command_RestartAppMutationVariables>(Base.Command_RestartAppDocument, options as any);
}


// Command_ClearState
export type UseCommand_ClearStateMutationOptions = MutationOpts<Base.Command_ClearStateMutation, Base.Command_ClearStateMutationVariables>;
export function useCommand_ClearStateMutation(options?: UseCommand_ClearStateMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_ClearStateMutation, Base.Command_ClearStateMutationVariables>(Base.Command_ClearStateDocument, options as any);
}


// Command_PurgeQueueByMessageId
export type UseCommand_PurgeQueueByMessageIdMutationOptions = MutationOpts<Base.Command_PurgeQueueByMessageIdMutation, Base.Command_PurgeQueueByMessageIdMutationVariables>;
export function useCommand_PurgeQueueByMessageIdMutation(options?: UseCommand_PurgeQueueByMessageIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_PurgeQueueByMessageIdMutation, Base.Command_PurgeQueueByMessageIdMutationVariables>(Base.Command_PurgeQueueByMessageIdDocument, options as any);
}


// Command_PurgeQueueByDeviceId
export type UseCommand_PurgeQueueByDeviceIdMutationOptions = MutationOpts<Base.Command_PurgeQueueByDeviceIdMutation, Base.Command_PurgeQueueByDeviceIdMutationVariables>;
export function useCommand_PurgeQueueByDeviceIdMutation(options?: UseCommand_PurgeQueueByDeviceIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_PurgeQueueByDeviceIdMutation, Base.Command_PurgeQueueByDeviceIdMutationVariables>(Base.Command_PurgeQueueByDeviceIdDocument, options as any);
}


// Command_PurgeQueueByNodeId
export type UseCommand_PurgeQueueByNodeIdMutationOptions = MutationOpts<Base.Command_PurgeQueueByNodeIdMutation, Base.Command_PurgeQueueByNodeIdMutationVariables>;
export function useCommand_PurgeQueueByNodeIdMutation(options?: UseCommand_PurgeQueueByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_PurgeQueueByNodeIdMutation, Base.Command_PurgeQueueByNodeIdMutationVariables>(Base.Command_PurgeQueueByNodeIdDocument, options as any);
}


// Command_SyncAll
export type UseCommand_SyncAllMutationOptions = MutationOpts<Base.Command_SyncAllMutation, Base.Command_SyncAllMutationVariables>;
export function useCommand_SyncAllMutation(options?: UseCommand_SyncAllMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_SyncAllMutation, Base.Command_SyncAllMutationVariables>(Base.Command_SyncAllDocument, options as any);
}


// Command_SyncSelected
export type UseCommand_SyncSelectedMutationOptions = MutationOpts<Base.Command_SyncSelectedMutation, Base.Command_SyncSelectedMutationVariables>;
export function useCommand_SyncSelectedMutation(options?: UseCommand_SyncSelectedMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_SyncSelectedMutation, Base.Command_SyncSelectedMutationVariables>(Base.Command_SyncSelectedDocument, options as any);
}


// Command_SyncFiles
export type UseCommand_SyncFilesMutationOptions = MutationOpts<Base.Command_SyncFilesMutation, Base.Command_SyncFilesMutationVariables>;
export function useCommand_SyncFilesMutation(options?: UseCommand_SyncFilesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_SyncFilesMutation, Base.Command_SyncFilesMutationVariables>(Base.Command_SyncFilesDocument, options as any);
}


// Command_SyncConfig
export type UseCommand_SyncConfigMutationOptions = MutationOpts<Base.Command_SyncConfigMutation, Base.Command_SyncConfigMutationVariables>;
export function useCommand_SyncConfigMutation(options?: UseCommand_SyncConfigMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_SyncConfigMutation, Base.Command_SyncConfigMutationVariables>(Base.Command_SyncConfigDocument, options as any);
}


// Command_SyncApplication
export type UseCommand_SyncApplicationMutationOptions = MutationOpts<Base.Command_SyncApplicationMutation, Base.Command_SyncApplicationMutationVariables>;
export function useCommand_SyncApplicationMutation(options?: UseCommand_SyncApplicationMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_SyncApplicationMutation, Base.Command_SyncApplicationMutationVariables>(Base.Command_SyncApplicationDocument, options as any);
}


// Command_SyncFirmware
export type UseCommand_SyncFirmwareMutationOptions = MutationOpts<Base.Command_SyncFirmwareMutation, Base.Command_SyncFirmwareMutationVariables>;
export function useCommand_SyncFirmwareMutation(options?: UseCommand_SyncFirmwareMutationOptions | AnyMutationOpts) {
  return useMutation<Base.Command_SyncFirmwareMutation, Base.Command_SyncFirmwareMutationVariables>(Base.Command_SyncFirmwareDocument, options as any);
}


// NodeConfigCounts
export type UseNodeConfigCountsQueryOptions = QueryOpts<Base.NodeConfigCountsQuery, Base.NodeConfigCountsQueryVariables>;
export function useNodeConfigCountsQuery(options?: UseNodeConfigCountsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodeConfigCountsQuery, Base.NodeConfigCountsQueryVariables>(Base.NodeConfigCountsDocument, options as any);
}
export type UseNodeConfigCountsLazyQueryOptions = LazyQueryOpts<Base.NodeConfigCountsQueryVariables>;
export function useNodeConfigCountsLazyQuery(options?: UseNodeConfigCountsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodeConfigCountsQuery, Base.NodeConfigCountsQueryVariables>(Base.NodeConfigCountsDocument, options as any);
}


// DeviceConfiguration
export type UseDeviceConfigurationQueryOptions = QueryOpts<Base.DeviceConfigurationQuery, Base.DeviceConfigurationQueryVariables>;
export function useDeviceConfigurationQuery(options?: UseDeviceConfigurationQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceConfigurationQuery, Base.DeviceConfigurationQueryVariables>(Base.DeviceConfigurationDocument, options as any);
}
export type UseDeviceConfigurationLazyQueryOptions = LazyQueryOpts<Base.DeviceConfigurationQueryVariables>;
export function useDeviceConfigurationLazyQuery(options?: UseDeviceConfigurationLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceConfigurationQuery, Base.DeviceConfigurationQueryVariables>(Base.DeviceConfigurationDocument, options as any);
}


// DeviceConfigurations
export type UseDeviceConfigurationsQueryOptions = QueryOpts<Base.DeviceConfigurationsQuery, Base.DeviceConfigurationsQueryVariables>;
export function useDeviceConfigurationsQuery(options?: UseDeviceConfigurationsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceConfigurationsQuery, Base.DeviceConfigurationsQueryVariables>(Base.DeviceConfigurationsDocument, options as any);
}
export type UseDeviceConfigurationsLazyQueryOptions = LazyQueryOpts<Base.DeviceConfigurationsQueryVariables>;
export function useDeviceConfigurationsLazyQuery(options?: UseDeviceConfigurationsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceConfigurationsQuery, Base.DeviceConfigurationsQueryVariables>(Base.DeviceConfigurationsDocument, options as any);
}


// AddDeviceConfiguration
export type UseAddDeviceConfigurationMutationOptions = MutationOpts<Base.AddDeviceConfigurationMutation, Base.AddDeviceConfigurationMutationVariables>;
export function useAddDeviceConfigurationMutation(options?: UseAddDeviceConfigurationMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddDeviceConfigurationMutation, Base.AddDeviceConfigurationMutationVariables>(Base.AddDeviceConfigurationDocument, options as any);
}


// UpdateDeviceConfiguration
export type UseUpdateDeviceConfigurationMutationOptions = MutationOpts<Base.UpdateDeviceConfigurationMutation, Base.UpdateDeviceConfigurationMutationVariables>;
export function useUpdateDeviceConfigurationMutation(options?: UseUpdateDeviceConfigurationMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateDeviceConfigurationMutation, Base.UpdateDeviceConfigurationMutationVariables>(Base.UpdateDeviceConfigurationDocument, options as any);
}


// DeleteDeviceConfiguration
export type UseDeleteDeviceConfigurationMutationOptions = MutationOpts<Base.DeleteDeviceConfigurationMutation, Base.DeleteDeviceConfigurationMutationVariables>;
export function useDeleteDeviceConfigurationMutation(options?: UseDeleteDeviceConfigurationMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteDeviceConfigurationMutation, Base.DeleteDeviceConfigurationMutationVariables>(Base.DeleteDeviceConfigurationDocument, options as any);
}


// FetchDeviceDisplayData
export type UseFetchDeviceDisplayDataQueryOptions = QueryOpts<Base.FetchDeviceDisplayDataQuery, Base.FetchDeviceDisplayDataQueryVariables>;
export function useFetchDeviceDisplayDataQuery(options?: UseFetchDeviceDisplayDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FetchDeviceDisplayDataQuery, Base.FetchDeviceDisplayDataQueryVariables>(Base.FetchDeviceDisplayDataDocument, options as any);
}
export type UseFetchDeviceDisplayDataLazyQueryOptions = LazyQueryOpts<Base.FetchDeviceDisplayDataQueryVariables>;
export function useFetchDeviceDisplayDataLazyQuery(options?: UseFetchDeviceDisplayDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FetchDeviceDisplayDataQuery, Base.FetchDeviceDisplayDataQueryVariables>(Base.FetchDeviceDisplayDataDocument, options as any);
}


// Devices
export type UseDevicesQueryOptions = QueryOpts<Base.DevicesQuery, Base.DevicesQueryVariables>;
export function useDevicesQuery(options?: UseDevicesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DevicesQuery, Base.DevicesQueryVariables>(Base.DevicesDocument, options as any);
}
export type UseDevicesLazyQueryOptions = LazyQueryOpts<Base.DevicesQueryVariables>;
export function useDevicesLazyQuery(options?: UseDevicesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DevicesQuery, Base.DevicesQueryVariables>(Base.DevicesDocument, options as any);
}


// DeviceUnique
export type UseDeviceUniqueQueryOptions = QueryOpts<Base.DeviceUniqueQuery, Base.DeviceUniqueQueryVariables>;
export function useDeviceUniqueQuery(options?: UseDeviceUniqueQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceUniqueQuery, Base.DeviceUniqueQueryVariables>(Base.DeviceUniqueDocument, options as any);
}
export type UseDeviceUniqueLazyQueryOptions = LazyQueryOpts<Base.DeviceUniqueQueryVariables>;
export function useDeviceUniqueLazyQuery(options?: UseDeviceUniqueLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceUniqueQuery, Base.DeviceUniqueQueryVariables>(Base.DeviceUniqueDocument, options as any);
}


// PackagesCompatible
export type UsePackagesCompatibleQueryOptions = QueryOpts<Base.PackagesCompatibleQuery, Base.PackagesCompatibleQueryVariables>;
export function usePackagesCompatibleQuery(options?: UsePackagesCompatibleQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackagesCompatibleQuery, Base.PackagesCompatibleQueryVariables>(Base.PackagesCompatibleDocument, options as any);
}
export type UsePackagesCompatibleLazyQueryOptions = LazyQueryOpts<Base.PackagesCompatibleQueryVariables>;
export function usePackagesCompatibleLazyQuery(options?: UsePackagesCompatibleLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackagesCompatibleQuery, Base.PackagesCompatibleQueryVariables>(Base.PackagesCompatibleDocument, options as any);
}


// Package
export type UsePackageQueryOptions = QueryOpts<Base.PackageQuery, Base.PackageQueryVariables>;
export function usePackageQuery(options?: UsePackageQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageQuery, Base.PackageQueryVariables>(Base.PackageDocument, options as any);
}
export type UsePackageLazyQueryOptions = LazyQueryOpts<Base.PackageQueryVariables>;
export function usePackageLazyQuery(options?: UsePackageLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageQuery, Base.PackageQueryVariables>(Base.PackageDocument, options as any);
}


// PackageByNodeId
export type UsePackageByNodeIdQueryOptions = QueryOpts<Base.PackageByNodeIdQuery, Base.PackageByNodeIdQueryVariables>;
export function usePackageByNodeIdQuery(options?: UsePackageByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageByNodeIdQuery, Base.PackageByNodeIdQueryVariables>(Base.PackageByNodeIdDocument, options as any);
}
export type UsePackageByNodeIdLazyQueryOptions = LazyQueryOpts<Base.PackageByNodeIdQueryVariables>;
export function usePackageByNodeIdLazyQuery(options?: UsePackageByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageByNodeIdQuery, Base.PackageByNodeIdQueryVariables>(Base.PackageByNodeIdDocument, options as any);
}


// DeletePackage
export type UseDeletePackageMutationOptions = MutationOpts<Base.DeletePackageMutation, Base.DeletePackageMutationVariables>;
export function useDeletePackageMutation(options?: UseDeletePackageMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeletePackageMutation, Base.DeletePackageMutationVariables>(Base.DeletePackageDocument, options as any);
}


// DeviceMessage
export type UseDeviceMessageQueryOptions = QueryOpts<Base.DeviceMessageQuery, Base.DeviceMessageQueryVariables>;
export function useDeviceMessageQuery(options?: UseDeviceMessageQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceMessageQuery, Base.DeviceMessageQueryVariables>(Base.DeviceMessageDocument, options as any);
}
export type UseDeviceMessageLazyQueryOptions = LazyQueryOpts<Base.DeviceMessageQueryVariables>;
export function useDeviceMessageLazyQuery(options?: UseDeviceMessageLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceMessageQuery, Base.DeviceMessageQueryVariables>(Base.DeviceMessageDocument, options as any);
}


// InheritedItems
export type UseInheritedItemsQueryOptions = QueryOpts<Base.InheritedItemsQuery, Base.InheritedItemsQueryVariables>;
export function useInheritedItemsQuery(options?: UseInheritedItemsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedItemsQuery, Base.InheritedItemsQueryVariables>(Base.InheritedItemsDocument, options as any);
}
export type UseInheritedItemsLazyQueryOptions = LazyQueryOpts<Base.InheritedItemsQueryVariables>;
export function useInheritedItemsLazyQuery(options?: UseInheritedItemsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedItemsQuery, Base.InheritedItemsQueryVariables>(Base.InheritedItemsDocument, options as any);
}


// InheritedFiles
export type UseInheritedFilesQueryOptions = QueryOpts<Base.InheritedFilesQuery, Base.InheritedFilesQueryVariables>;
export function useInheritedFilesQuery(options?: UseInheritedFilesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedFilesQuery, Base.InheritedFilesQueryVariables>(Base.InheritedFilesDocument, options as any);
}
export type UseInheritedFilesLazyQueryOptions = LazyQueryOpts<Base.InheritedFilesQueryVariables>;
export function useInheritedFilesLazyQuery(options?: UseInheritedFilesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedFilesQuery, Base.InheritedFilesQueryVariables>(Base.InheritedFilesDocument, options as any);
}


// InheritedConfiguration
export type UseInheritedConfigurationQueryOptions = QueryOpts<Base.InheritedConfigurationQuery, Base.InheritedConfigurationQueryVariables>;
export function useInheritedConfigurationQuery(options?: UseInheritedConfigurationQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedConfigurationQuery, Base.InheritedConfigurationQueryVariables>(Base.InheritedConfigurationDocument, options as any);
}
export type UseInheritedConfigurationLazyQueryOptions = LazyQueryOpts<Base.InheritedConfigurationQueryVariables>;
export function useInheritedConfigurationLazyQuery(options?: UseInheritedConfigurationLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedConfigurationQuery, Base.InheritedConfigurationQueryVariables>(Base.InheritedConfigurationDocument, options as any);
}


// InheritedFirmware
export type UseInheritedFirmwareQueryOptions = QueryOpts<Base.InheritedFirmwareQuery, Base.InheritedFirmwareQueryVariables>;
export function useInheritedFirmwareQuery(options?: UseInheritedFirmwareQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedFirmwareQuery, Base.InheritedFirmwareQueryVariables>(Base.InheritedFirmwareDocument, options as any);
}
export type UseInheritedFirmwareLazyQueryOptions = LazyQueryOpts<Base.InheritedFirmwareQueryVariables>;
export function useInheritedFirmwareLazyQuery(options?: UseInheritedFirmwareLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedFirmwareQuery, Base.InheritedFirmwareQueryVariables>(Base.InheritedFirmwareDocument, options as any);
}


// InheritedApplication
export type UseInheritedApplicationQueryOptions = QueryOpts<Base.InheritedApplicationQuery, Base.InheritedApplicationQueryVariables>;
export function useInheritedApplicationQuery(options?: UseInheritedApplicationQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedApplicationQuery, Base.InheritedApplicationQueryVariables>(Base.InheritedApplicationDocument, options as any);
}
export type UseInheritedApplicationLazyQueryOptions = LazyQueryOpts<Base.InheritedApplicationQueryVariables>;
export function useInheritedApplicationLazyQuery(options?: UseInheritedApplicationLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedApplicationQuery, Base.InheritedApplicationQueryVariables>(Base.InheritedApplicationDocument, options as any);
}


// InheritedAssetsAndConfigurations
export type UseInheritedAssetsAndConfigurationsQueryOptions = QueryOpts<Base.InheritedAssetsAndConfigurationsQuery, Base.InheritedAssetsAndConfigurationsQueryVariables>;
export function useInheritedAssetsAndConfigurationsQuery(options?: UseInheritedAssetsAndConfigurationsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InheritedAssetsAndConfigurationsQuery, Base.InheritedAssetsAndConfigurationsQueryVariables>(Base.InheritedAssetsAndConfigurationsDocument, options as any);
}
export type UseInheritedAssetsAndConfigurationsLazyQueryOptions = LazyQueryOpts<Base.InheritedAssetsAndConfigurationsQueryVariables>;
export function useInheritedAssetsAndConfigurationsLazyQuery(options?: UseInheritedAssetsAndConfigurationsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InheritedAssetsAndConfigurationsQuery, Base.InheritedAssetsAndConfigurationsQueryVariables>(Base.InheritedAssetsAndConfigurationsDocument, options as any);
}


// PackageLink
export type UsePackageLinkQueryOptions = QueryOpts<Base.PackageLinkQuery, Base.PackageLinkQueryVariables>;
export function usePackageLinkQuery(options?: UsePackageLinkQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageLinkQuery, Base.PackageLinkQueryVariables>(Base.PackageLinkDocument, options as any);
}
export type UsePackageLinkLazyQueryOptions = LazyQueryOpts<Base.PackageLinkQueryVariables>;
export function usePackageLinkLazyQuery(options?: UsePackageLinkLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageLinkQuery, Base.PackageLinkQueryVariables>(Base.PackageLinkDocument, options as any);
}


// PackageLinks
export type UsePackageLinksQueryOptions = QueryOpts<Base.PackageLinksQuery, Base.PackageLinksQueryVariables>;
export function usePackageLinksQuery(options?: UsePackageLinksQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageLinksQuery, Base.PackageLinksQueryVariables>(Base.PackageLinksDocument, options as any);
}
export type UsePackageLinksLazyQueryOptions = LazyQueryOpts<Base.PackageLinksQueryVariables>;
export function usePackageLinksLazyQuery(options?: UsePackageLinksLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageLinksQuery, Base.PackageLinksQueryVariables>(Base.PackageLinksDocument, options as any);
}


// PackageLinksCheckRetired
export type UsePackageLinksCheckRetiredQueryOptions = QueryOpts<Base.PackageLinksCheckRetiredQuery, Base.PackageLinksCheckRetiredQueryVariables>;
export function usePackageLinksCheckRetiredQuery(options?: UsePackageLinksCheckRetiredQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PackageLinksCheckRetiredQuery, Base.PackageLinksCheckRetiredQueryVariables>(Base.PackageLinksCheckRetiredDocument, options as any);
}
export type UsePackageLinksCheckRetiredLazyQueryOptions = LazyQueryOpts<Base.PackageLinksCheckRetiredQueryVariables>;
export function usePackageLinksCheckRetiredLazyQuery(options?: UsePackageLinksCheckRetiredLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PackageLinksCheckRetiredQuery, Base.PackageLinksCheckRetiredQueryVariables>(Base.PackageLinksCheckRetiredDocument, options as any);
}


// AddPackageLink
export type UseAddPackageLinkMutationOptions = MutationOpts<Base.AddPackageLinkMutation, Base.AddPackageLinkMutationVariables>;
export function useAddPackageLinkMutation(options?: UseAddPackageLinkMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddPackageLinkMutation, Base.AddPackageLinkMutationVariables>(Base.AddPackageLinkDocument, options as any);
}


// UpdatePackageLink
export type UseUpdatePackageLinkMutationOptions = MutationOpts<Base.UpdatePackageLinkMutation, Base.UpdatePackageLinkMutationVariables>;
export function useUpdatePackageLinkMutation(options?: UseUpdatePackageLinkMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdatePackageLinkMutation, Base.UpdatePackageLinkMutationVariables>(Base.UpdatePackageLinkDocument, options as any);
}


// RemovePackageLink
export type UseRemovePackageLinkMutationOptions = MutationOpts<Base.RemovePackageLinkMutation, Base.RemovePackageLinkMutationVariables>;
export function useRemovePackageLinkMutation(options?: UseRemovePackageLinkMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RemovePackageLinkMutation, Base.RemovePackageLinkMutationVariables>(Base.RemovePackageLinkDocument, options as any);
}


// MessageHistory
export type UseMessageHistoryQueryOptions = QueryOpts<Base.MessageHistoryQuery, Base.MessageHistoryQueryVariables>;
export function useMessageHistoryQuery(options?: UseMessageHistoryQueryOptions | AnyQueryOpts) {
  return useQuery<Base.MessageHistoryQuery, Base.MessageHistoryQueryVariables>(Base.MessageHistoryDocument, options as any);
}
export type UseMessageHistoryLazyQueryOptions = LazyQueryOpts<Base.MessageHistoryQueryVariables>;
export function useMessageHistoryLazyQuery(options?: UseMessageHistoryLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.MessageHistoryQuery, Base.MessageHistoryQueryVariables>(Base.MessageHistoryDocument, options as any);
}


// MessageHistoryById
export type UseMessageHistoryByIdQueryOptions = QueryOpts<Base.MessageHistoryByIdQuery, Base.MessageHistoryByIdQueryVariables>;
export function useMessageHistoryByIdQuery(options?: UseMessageHistoryByIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.MessageHistoryByIdQuery, Base.MessageHistoryByIdQueryVariables>(Base.MessageHistoryByIdDocument, options as any);
}
export type UseMessageHistoryByIdLazyQueryOptions = LazyQueryOpts<Base.MessageHistoryByIdQueryVariables>;
export function useMessageHistoryByIdLazyQuery(options?: UseMessageHistoryByIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.MessageHistoryByIdQuery, Base.MessageHistoryByIdQueryVariables>(Base.MessageHistoryByIdDocument, options as any);
}


// InviteCode
export type UseInviteCodeQueryOptions = QueryOpts<Base.InviteCodeQuery, Base.InviteCodeQueryVariables>;
export function useInviteCodeQuery(options?: UseInviteCodeQueryOptions | AnyQueryOpts) {
  return useQuery<Base.InviteCodeQuery, Base.InviteCodeQueryVariables>(Base.InviteCodeDocument, options as any);
}
export type UseInviteCodeLazyQueryOptions = LazyQueryOpts<Base.InviteCodeQueryVariables>;
export function useInviteCodeLazyQuery(options?: UseInviteCodeLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.InviteCodeQuery, Base.InviteCodeQueryVariables>(Base.InviteCodeDocument, options as any);
}


// SerialNumber
export type UseSerialNumberQueryOptions = QueryOpts<Base.SerialNumberQuery, Base.SerialNumberQueryVariables>;
export function useSerialNumberQuery(options?: UseSerialNumberQueryOptions | AnyQueryOpts) {
  return useQuery<Base.SerialNumberQuery, Base.SerialNumberQueryVariables>(Base.SerialNumberDocument, options as any);
}
export type UseSerialNumberLazyQueryOptions = LazyQueryOpts<Base.SerialNumberQueryVariables>;
export function useSerialNumberLazyQuery(options?: UseSerialNumberLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.SerialNumberQuery, Base.SerialNumberQueryVariables>(Base.SerialNumberDocument, options as any);
}


// AddTabletAndInvite
export type UseAddTabletAndInviteMutationOptions = MutationOpts<Base.AddTabletAndInviteMutation, Base.AddTabletAndInviteMutationVariables>;
export function useAddTabletAndInviteMutation(options?: UseAddTabletAndInviteMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddTabletAndInviteMutation, Base.AddTabletAndInviteMutationVariables>(Base.AddTabletAndInviteDocument, options as any);
}


// ReInviteTablet
export type UseReInviteTabletMutationOptions = MutationOpts<Base.ReInviteTabletMutation, Base.ReInviteTabletMutationVariables>;
export function useReInviteTabletMutation(options?: UseReInviteTabletMutationOptions | AnyMutationOpts) {
  return useMutation<Base.ReInviteTabletMutation, Base.ReInviteTabletMutationVariables>(Base.ReInviteTabletDocument, options as any);
}


// DeleteTablet
export type UseDeleteTabletMutationOptions = MutationOpts<Base.DeleteTabletMutation, Base.DeleteTabletMutationVariables>;
export function useDeleteTabletMutation(options?: UseDeleteTabletMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteTabletMutation, Base.DeleteTabletMutationVariables>(Base.DeleteTabletDocument, options as any);
}


// Transactions
export type UseTransactionsQueryOptions = QueryOpts<Base.TransactionsQuery, Base.TransactionsQueryVariables>;
export function useTransactionsQuery(options?: UseTransactionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TransactionsQuery, Base.TransactionsQueryVariables>(Base.TransactionsDocument, options as any);
}
export type UseTransactionsLazyQueryOptions = LazyQueryOpts<Base.TransactionsQueryVariables>;
export function useTransactionsLazyQuery(options?: UseTransactionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TransactionsQuery, Base.TransactionsQueryVariables>(Base.TransactionsDocument, options as any);
}


// DeviceViewData
export type UseDeviceViewDataQueryOptions = QueryOpts<Base.DeviceViewDataQuery, Base.DeviceViewDataQueryVariables>;
export function useDeviceViewDataQuery(options?: UseDeviceViewDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceViewDataQuery, Base.DeviceViewDataQueryVariables>(Base.DeviceViewDataDocument, options as any);
}
export type UseDeviceViewDataLazyQueryOptions = LazyQueryOpts<Base.DeviceViewDataQueryVariables>;
export function useDeviceViewDataLazyQuery(options?: UseDeviceViewDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceViewDataQuery, Base.DeviceViewDataQueryVariables>(Base.DeviceViewDataDocument, options as any);
}


// DeviceMetrics
export type UseDeviceMetricsQueryOptions = QueryOpts<Base.DeviceMetricsQuery, Base.DeviceMetricsQueryVariables>;
export function useDeviceMetricsQuery(options?: UseDeviceMetricsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DeviceMetricsQuery, Base.DeviceMetricsQueryVariables>(Base.DeviceMetricsDocument, options as any);
}
export type UseDeviceMetricsLazyQueryOptions = LazyQueryOpts<Base.DeviceMetricsQueryVariables>;
export function useDeviceMetricsLazyQuery(options?: UseDeviceMetricsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DeviceMetricsQuery, Base.DeviceMetricsQueryVariables>(Base.DeviceMetricsDocument, options as any);
}


// TransactionsDailyAggregate
export type UseTransactionsDailyAggregateQueryOptions = QueryOpts<Base.TransactionsDailyAggregateQuery, Base.TransactionsDailyAggregateQueryVariables>;
export function useTransactionsDailyAggregateQuery(options?: UseTransactionsDailyAggregateQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TransactionsDailyAggregateQuery, Base.TransactionsDailyAggregateQueryVariables>(Base.TransactionsDailyAggregateDocument, options as any);
}
export type UseTransactionsDailyAggregateLazyQueryOptions = LazyQueryOpts<Base.TransactionsDailyAggregateQueryVariables>;
export function useTransactionsDailyAggregateLazyQuery(options?: UseTransactionsDailyAggregateLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TransactionsDailyAggregateQuery, Base.TransactionsDailyAggregateQueryVariables>(Base.TransactionsDailyAggregateDocument, options as any);
}


// TransactionsDailyAggregateIncludeChildren
export type UseTransactionsDailyAggregateIncludeChildrenQueryOptions = QueryOpts<Base.TransactionsDailyAggregateIncludeChildrenQuery, Base.TransactionsDailyAggregateIncludeChildrenQueryVariables>;
export function useTransactionsDailyAggregateIncludeChildrenQuery(options?: UseTransactionsDailyAggregateIncludeChildrenQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TransactionsDailyAggregateIncludeChildrenQuery, Base.TransactionsDailyAggregateIncludeChildrenQueryVariables>(Base.TransactionsDailyAggregateIncludeChildrenDocument, options as any);
}
export type UseTransactionsDailyAggregateIncludeChildrenLazyQueryOptions = LazyQueryOpts<Base.TransactionsDailyAggregateIncludeChildrenQueryVariables>;
export function useTransactionsDailyAggregateIncludeChildrenLazyQuery(options?: UseTransactionsDailyAggregateIncludeChildrenLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TransactionsDailyAggregateIncludeChildrenQuery, Base.TransactionsDailyAggregateIncludeChildrenQueryVariables>(Base.TransactionsDailyAggregateIncludeChildrenDocument, options as any);
}


// Transactions30DaysAllStates
export type UseTransactions30DaysAllStatesQueryOptions = QueryOpts<Base.Transactions30DaysAllStatesQuery, Base.Transactions30DaysAllStatesQueryVariables>;
export function useTransactions30DaysAllStatesQuery(options?: UseTransactions30DaysAllStatesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.Transactions30DaysAllStatesQuery, Base.Transactions30DaysAllStatesQueryVariables>(Base.Transactions30DaysAllStatesDocument, options as any);
}
export type UseTransactions30DaysAllStatesLazyQueryOptions = LazyQueryOpts<Base.Transactions30DaysAllStatesQueryVariables>;
export function useTransactions30DaysAllStatesLazyQuery(options?: UseTransactions30DaysAllStatesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.Transactions30DaysAllStatesQuery, Base.Transactions30DaysAllStatesQueryVariables>(Base.Transactions30DaysAllStatesDocument, options as any);
}


// FetchVerificationImageBySessionId
export type UseFetchVerificationImageBySessionIdQueryOptions = QueryOpts<Base.FetchVerificationImageBySessionIdQuery, Base.FetchVerificationImageBySessionIdQueryVariables>;
export function useFetchVerificationImageBySessionIdQuery(options?: UseFetchVerificationImageBySessionIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FetchVerificationImageBySessionIdQuery, Base.FetchVerificationImageBySessionIdQueryVariables>(Base.FetchVerificationImageBySessionIdDocument, options as any);
}
export type UseFetchVerificationImageBySessionIdLazyQueryOptions = LazyQueryOpts<Base.FetchVerificationImageBySessionIdQueryVariables>;
export function useFetchVerificationImageBySessionIdLazyQuery(options?: UseFetchVerificationImageBySessionIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FetchVerificationImageBySessionIdQuery, Base.FetchVerificationImageBySessionIdQueryVariables>(Base.FetchVerificationImageBySessionIdDocument, options as any);
}


// ReplayTransactions
export type UseReplayTransactionsMutationOptions = MutationOpts<Base.ReplayTransactionsMutation, Base.ReplayTransactionsMutationVariables>;
export function useReplayTransactionsMutation(options?: UseReplayTransactionsMutationOptions | AnyMutationOpts) {
  return useMutation<Base.ReplayTransactionsMutation, Base.ReplayTransactionsMutationVariables>(Base.ReplayTransactionsDocument, options as any);
}


// DevicesMetrics
export type UseDevicesMetricsQueryOptions = QueryOpts<Base.DevicesMetricsQuery, Base.DevicesMetricsQueryVariables>;
export function useDevicesMetricsQuery(options?: UseDevicesMetricsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DevicesMetricsQuery, Base.DevicesMetricsQueryVariables>(Base.DevicesMetricsDocument, options as any);
}
export type UseDevicesMetricsLazyQueryOptions = LazyQueryOpts<Base.DevicesMetricsQueryVariables>;
export function useDevicesMetricsLazyQuery(options?: UseDevicesMetricsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DevicesMetricsQuery, Base.DevicesMetricsQueryVariables>(Base.DevicesMetricsDocument, options as any);
}


// DevicesMetricsNoPeople
export type UseDevicesMetricsNoPeopleQueryOptions = QueryOpts<Base.DevicesMetricsNoPeopleQuery, Base.DevicesMetricsNoPeopleQueryVariables>;
export function useDevicesMetricsNoPeopleQuery(options?: UseDevicesMetricsNoPeopleQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DevicesMetricsNoPeopleQuery, Base.DevicesMetricsNoPeopleQueryVariables>(Base.DevicesMetricsNoPeopleDocument, options as any);
}
export type UseDevicesMetricsNoPeopleLazyQueryOptions = LazyQueryOpts<Base.DevicesMetricsNoPeopleQueryVariables>;
export function useDevicesMetricsNoPeopleLazyQuery(options?: UseDevicesMetricsNoPeopleLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DevicesMetricsNoPeopleQuery, Base.DevicesMetricsNoPeopleQueryVariables>(Base.DevicesMetricsNoPeopleDocument, options as any);
}


// CurrentUser
export type UseCurrentUserQueryOptions = QueryOpts<Base.CurrentUserQuery, Base.CurrentUserQueryVariables>;
export function useCurrentUserQuery(options?: UseCurrentUserQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CurrentUserQuery, Base.CurrentUserQueryVariables>(Base.CurrentUserDocument, options as any);
}
export type UseCurrentUserLazyQueryOptions = LazyQueryOpts<Base.CurrentUserQueryVariables>;
export function useCurrentUserLazyQuery(options?: UseCurrentUserLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CurrentUserQuery, Base.CurrentUserQueryVariables>(Base.CurrentUserDocument, options as any);
}


// IntrospectedPermissions
export type UseIntrospectedPermissionsQueryOptions = QueryOpts<Base.IntrospectedPermissionsQuery, Base.IntrospectedPermissionsQueryVariables>;
export function useIntrospectedPermissionsQuery(options?: UseIntrospectedPermissionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.IntrospectedPermissionsQuery, Base.IntrospectedPermissionsQueryVariables>(Base.IntrospectedPermissionsDocument, options as any);
}
export type UseIntrospectedPermissionsLazyQueryOptions = LazyQueryOpts<Base.IntrospectedPermissionsQueryVariables>;
export function useIntrospectedPermissionsLazyQuery(options?: UseIntrospectedPermissionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.IntrospectedPermissionsQuery, Base.IntrospectedPermissionsQueryVariables>(Base.IntrospectedPermissionsDocument, options as any);
}


// Node
export type UseNodeQueryOptions = QueryOpts<Base.NodeQuery, Base.NodeQueryVariables>;
export function useNodeQuery(options?: UseNodeQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodeQuery, Base.NodeQueryVariables>(Base.NodeDocument, options as any);
}
export type UseNodeLazyQueryOptions = LazyQueryOpts<Base.NodeQueryVariables>;
export function useNodeLazyQuery(options?: UseNodeLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodeQuery, Base.NodeQueryVariables>(Base.NodeDocument, options as any);
}


// FetchMoveDeviceNodes
export type UseFetchMoveDeviceNodesQueryOptions = QueryOpts<Base.FetchMoveDeviceNodesQuery, Base.FetchMoveDeviceNodesQueryVariables>;
export function useFetchMoveDeviceNodesQuery(options?: UseFetchMoveDeviceNodesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FetchMoveDeviceNodesQuery, Base.FetchMoveDeviceNodesQueryVariables>(Base.FetchMoveDeviceNodesDocument, options as any);
}
export type UseFetchMoveDeviceNodesLazyQueryOptions = LazyQueryOpts<Base.FetchMoveDeviceNodesQueryVariables>;
export function useFetchMoveDeviceNodesLazyQuery(options?: UseFetchMoveDeviceNodesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FetchMoveDeviceNodesQuery, Base.FetchMoveDeviceNodesQueryVariables>(Base.FetchMoveDeviceNodesDocument, options as any);
}


// NodesWalkingUp
export type UseNodesWalkingUpQueryOptions = QueryOpts<Base.NodesWalkingUpQuery, Base.NodesWalkingUpQueryVariables>;
export function useNodesWalkingUpQuery(options?: UseNodesWalkingUpQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodesWalkingUpQuery, Base.NodesWalkingUpQueryVariables>(Base.NodesWalkingUpDocument, options as any);
}
export type UseNodesWalkingUpLazyQueryOptions = LazyQueryOpts<Base.NodesWalkingUpQueryVariables>;
export function useNodesWalkingUpLazyQuery(options?: UseNodesWalkingUpLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodesWalkingUpQuery, Base.NodesWalkingUpQueryVariables>(Base.NodesWalkingUpDocument, options as any);
}


// FindQuickDeployTargetNode
export type UseFindQuickDeployTargetNodeQueryOptions = QueryOpts<Base.FindQuickDeployTargetNodeQuery, Base.FindQuickDeployTargetNodeQueryVariables>;
export function useFindQuickDeployTargetNodeQuery(options?: UseFindQuickDeployTargetNodeQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FindQuickDeployTargetNodeQuery, Base.FindQuickDeployTargetNodeQueryVariables>(Base.FindQuickDeployTargetNodeDocument, options as any);
}
export type UseFindQuickDeployTargetNodeLazyQueryOptions = LazyQueryOpts<Base.FindQuickDeployTargetNodeQueryVariables>;
export function useFindQuickDeployTargetNodeLazyQuery(options?: UseFindQuickDeployTargetNodeLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FindQuickDeployTargetNodeQuery, Base.FindQuickDeployTargetNodeQueryVariables>(Base.FindQuickDeployTargetNodeDocument, options as any);
}


// NodeWithAdjacentChildren
export type UseNodeWithAdjacentChildrenQueryOptions = QueryOpts<Base.NodeWithAdjacentChildrenQuery, Base.NodeWithAdjacentChildrenQueryVariables>;
export function useNodeWithAdjacentChildrenQuery(options?: UseNodeWithAdjacentChildrenQueryOptions | AnyQueryOpts) {
  return useQuery<Base.NodeWithAdjacentChildrenQuery, Base.NodeWithAdjacentChildrenQueryVariables>(Base.NodeWithAdjacentChildrenDocument, options as any);
}
export type UseNodeWithAdjacentChildrenLazyQueryOptions = LazyQueryOpts<Base.NodeWithAdjacentChildrenQueryVariables>;
export function useNodeWithAdjacentChildrenLazyQuery(options?: UseNodeWithAdjacentChildrenLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.NodeWithAdjacentChildrenQuery, Base.NodeWithAdjacentChildrenQueryVariables>(Base.NodeWithAdjacentChildrenDocument, options as any);
}


// FetchNodeSyntheticNodes
export type UseFetchNodeSyntheticNodesQueryOptions = QueryOpts<Base.FetchNodeSyntheticNodesQuery, Base.FetchNodeSyntheticNodesQueryVariables>;
export function useFetchNodeSyntheticNodesQuery(options?: UseFetchNodeSyntheticNodesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FetchNodeSyntheticNodesQuery, Base.FetchNodeSyntheticNodesQueryVariables>(Base.FetchNodeSyntheticNodesDocument, options as any);
}
export type UseFetchNodeSyntheticNodesLazyQueryOptions = LazyQueryOpts<Base.FetchNodeSyntheticNodesQueryVariables>;
export function useFetchNodeSyntheticNodesLazyQuery(options?: UseFetchNodeSyntheticNodesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FetchNodeSyntheticNodesQuery, Base.FetchNodeSyntheticNodesQueryVariables>(Base.FetchNodeSyntheticNodesDocument, options as any);
}


// UpdateNode
export type UseUpdateNodeMutationOptions = MutationOpts<Base.UpdateNodeMutation, Base.UpdateNodeMutationVariables>;
export function useUpdateNodeMutation(options?: UseUpdateNodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateNodeMutation, Base.UpdateNodeMutationVariables>(Base.UpdateNodeDocument, options as any);
}


// AddNode
export type UseAddNodeMutationOptions = MutationOpts<Base.AddNodeMutation, Base.AddNodeMutationVariables>;
export function useAddNodeMutation(options?: UseAddNodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddNodeMutation, Base.AddNodeMutationVariables>(Base.AddNodeDocument, options as any);
}


// DeleteNode
export type UseDeleteNodeMutationOptions = MutationOpts<Base.DeleteNodeMutation, Base.DeleteNodeMutationVariables>;
export function useDeleteNodeMutation(options?: UseDeleteNodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteNodeMutation, Base.DeleteNodeMutationVariables>(Base.DeleteNodeDocument, options as any);
}


// BusinessDomains
export type UseBusinessDomainsQueryOptions = QueryOpts<Base.BusinessDomainsQuery, Base.BusinessDomainsQueryVariables>;
export function useBusinessDomainsQuery(options?: UseBusinessDomainsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.BusinessDomainsQuery, Base.BusinessDomainsQueryVariables>(Base.BusinessDomainsDocument, options as any);
}
export type UseBusinessDomainsLazyQueryOptions = LazyQueryOpts<Base.BusinessDomainsQueryVariables>;
export function useBusinessDomainsLazyQuery(options?: UseBusinessDomainsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.BusinessDomainsQuery, Base.BusinessDomainsQueryVariables>(Base.BusinessDomainsDocument, options as any);
}


// AddBusinessDomain
export type UseAddBusinessDomainMutationOptions = MutationOpts<Base.AddBusinessDomainMutation, Base.AddBusinessDomainMutationVariables>;
export function useAddBusinessDomainMutation(options?: UseAddBusinessDomainMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddBusinessDomainMutation, Base.AddBusinessDomainMutationVariables>(Base.AddBusinessDomainDocument, options as any);
}


// RemoveBusinessDomain
export type UseRemoveBusinessDomainMutationOptions = MutationOpts<Base.RemoveBusinessDomainMutation, Base.RemoveBusinessDomainMutationVariables>;
export function useRemoveBusinessDomainMutation(options?: UseRemoveBusinessDomainMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RemoveBusinessDomainMutation, Base.RemoveBusinessDomainMutationVariables>(Base.RemoveBusinessDomainDocument, options as any);
}


// UserGroups
export type UseUserGroupsQueryOptions = QueryOpts<Base.UserGroupsQuery, Base.UserGroupsQueryVariables>;
export function useUserGroupsQuery(options?: UseUserGroupsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.UserGroupsQuery, Base.UserGroupsQueryVariables>(Base.UserGroupsDocument, options as any);
}
export type UseUserGroupsLazyQueryOptions = LazyQueryOpts<Base.UserGroupsQueryVariables>;
export function useUserGroupsLazyQuery(options?: UseUserGroupsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.UserGroupsQuery, Base.UserGroupsQueryVariables>(Base.UserGroupsDocument, options as any);
}


// UserGroupsByNodeId
export type UseUserGroupsByNodeIdQueryOptions = QueryOpts<Base.UserGroupsByNodeIdQuery, Base.UserGroupsByNodeIdQueryVariables>;
export function useUserGroupsByNodeIdQuery(options?: UseUserGroupsByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.UserGroupsByNodeIdQuery, Base.UserGroupsByNodeIdQueryVariables>(Base.UserGroupsByNodeIdDocument, options as any);
}
export type UseUserGroupsByNodeIdLazyQueryOptions = LazyQueryOpts<Base.UserGroupsByNodeIdQueryVariables>;
export function useUserGroupsByNodeIdLazyQuery(options?: UseUserGroupsByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.UserGroupsByNodeIdQuery, Base.UserGroupsByNodeIdQueryVariables>(Base.UserGroupsByNodeIdDocument, options as any);
}


// AddUserGroup
export type UseAddUserGroupMutationOptions = MutationOpts<Base.AddUserGroupMutation, Base.AddUserGroupMutationVariables>;
export function useAddUserGroupMutation(options?: UseAddUserGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddUserGroupMutation, Base.AddUserGroupMutationVariables>(Base.AddUserGroupDocument, options as any);
}


// UpdateUserGroup
export type UseUpdateUserGroupMutationOptions = MutationOpts<Base.UpdateUserGroupMutation, Base.UpdateUserGroupMutationVariables>;
export function useUpdateUserGroupMutation(options?: UseUpdateUserGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateUserGroupMutation, Base.UpdateUserGroupMutationVariables>(Base.UpdateUserGroupDocument, options as any);
}


// DeleteUserGroup
export type UseDeleteUserGroupMutationOptions = MutationOpts<Base.DeleteUserGroupMutation, Base.DeleteUserGroupMutationVariables>;
export function useDeleteUserGroupMutation(options?: UseDeleteUserGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteUserGroupMutation, Base.DeleteUserGroupMutationVariables>(Base.DeleteUserGroupDocument, options as any);
}


// GetUsersByNodeId
export type UseGetUsersByNodeIdQueryOptions = QueryOpts<Base.GetUsersByNodeIdQuery, Base.GetUsersByNodeIdQueryVariables>;
export function useGetUsersByNodeIdQuery(options?: UseGetUsersByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetUsersByNodeIdQuery, Base.GetUsersByNodeIdQueryVariables>(Base.GetUsersByNodeIdDocument, options as any);
}
export type UseGetUsersByNodeIdLazyQueryOptions = LazyQueryOpts<Base.GetUsersByNodeIdQueryVariables>;
export function useGetUsersByNodeIdLazyQuery(options?: UseGetUsersByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetUsersByNodeIdQuery, Base.GetUsersByNodeIdQueryVariables>(Base.GetUsersByNodeIdDocument, options as any);
}


// GetUser
export type UseGetUserQueryOptions = QueryOpts<Base.GetUserQuery, Base.GetUserQueryVariables>;
export function useGetUserQuery(options?: UseGetUserQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetUserQuery, Base.GetUserQueryVariables>(Base.GetUserDocument, options as any);
}
export type UseGetUserLazyQueryOptions = LazyQueryOpts<Base.GetUserQueryVariables>;
export function useGetUserLazyQuery(options?: UseGetUserLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetUserQuery, Base.GetUserQueryVariables>(Base.GetUserDocument, options as any);
}


// GetUserByNodeId
export type UseGetUserByNodeIdQueryOptions = QueryOpts<Base.GetUserByNodeIdQuery, Base.GetUserByNodeIdQueryVariables>;
export function useGetUserByNodeIdQuery(options?: UseGetUserByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetUserByNodeIdQuery, Base.GetUserByNodeIdQueryVariables>(Base.GetUserByNodeIdDocument, options as any);
}
export type UseGetUserByNodeIdLazyQueryOptions = LazyQueryOpts<Base.GetUserByNodeIdQueryVariables>;
export function useGetUserByNodeIdLazyQuery(options?: UseGetUserByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetUserByNodeIdQuery, Base.GetUserByNodeIdQueryVariables>(Base.GetUserByNodeIdDocument, options as any);
}


// AddUser
export type UseAddUserMutationOptions = MutationOpts<Base.AddUserMutation, Base.AddUserMutationVariables>;
export function useAddUserMutation(options?: UseAddUserMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddUserMutation, Base.AddUserMutationVariables>(Base.AddUserDocument, options as any);
}


// InviteUser
export type UseInviteUserMutationOptions = MutationOpts<Base.InviteUserMutation, Base.InviteUserMutationVariables>;
export function useInviteUserMutation(options?: UseInviteUserMutationOptions | AnyMutationOpts) {
  return useMutation<Base.InviteUserMutation, Base.InviteUserMutationVariables>(Base.InviteUserDocument, options as any);
}


// AddExistingUser
export type UseAddExistingUserMutationOptions = MutationOpts<Base.AddExistingUserMutation, Base.AddExistingUserMutationVariables>;
export function useAddExistingUserMutation(options?: UseAddExistingUserMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExistingUserMutation, Base.AddExistingUserMutationVariables>(Base.AddExistingUserDocument, options as any);
}


// UpdateUser
export type UseUpdateUserMutationOptions = MutationOpts<Base.UpdateUserMutation, Base.UpdateUserMutationVariables>;
export function useUpdateUserMutation(options?: UseUpdateUserMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateUserMutation, Base.UpdateUserMutationVariables>(Base.UpdateUserDocument, options as any);
}


// UpdateUserByNodeId
export type UseUpdateUserByNodeIdMutationOptions = MutationOpts<Base.UpdateUserByNodeIdMutation, Base.UpdateUserByNodeIdMutationVariables>;
export function useUpdateUserByNodeIdMutation(options?: UseUpdateUserByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateUserByNodeIdMutation, Base.UpdateUserByNodeIdMutationVariables>(Base.UpdateUserByNodeIdDocument, options as any);
}


// DeleteUser
export type UseDeleteUserMutationOptions = MutationOpts<Base.DeleteUserMutation, Base.DeleteUserMutationVariables>;
export function useDeleteUserMutation(options?: UseDeleteUserMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteUserMutation, Base.DeleteUserMutationVariables>(Base.DeleteUserDocument, options as any);
}


// DeleteUserByNodeId
export type UseDeleteUserByNodeIdMutationOptions = MutationOpts<Base.DeleteUserByNodeIdMutation, Base.DeleteUserByNodeIdMutationVariables>;
export function useDeleteUserByNodeIdMutation(options?: UseDeleteUserByNodeIdMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteUserByNodeIdMutation, Base.DeleteUserByNodeIdMutationVariables>(Base.DeleteUserByNodeIdDocument, options as any);
}


// UpdatePassword
export type UseUpdatePasswordMutationOptions = MutationOpts<Base.UpdatePasswordMutation, Base.UpdatePasswordMutationVariables>;
export function useUpdatePasswordMutation(options?: UseUpdatePasswordMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdatePasswordMutation, Base.UpdatePasswordMutationVariables>(Base.UpdatePasswordDocument, options as any);
}


// ClockGroup
export type UseClockGroupQueryOptions = QueryOpts<Base.ClockGroupQuery, Base.ClockGroupQueryVariables>;
export function useClockGroupQuery(options?: UseClockGroupQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ClockGroupQuery, Base.ClockGroupQueryVariables>(Base.ClockGroupDocument, options as any);
}
export type UseClockGroupLazyQueryOptions = LazyQueryOpts<Base.ClockGroupQueryVariables>;
export function useClockGroupLazyQuery(options?: UseClockGroupLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ClockGroupQuery, Base.ClockGroupQueryVariables>(Base.ClockGroupDocument, options as any);
}


// ClockGroups
export type UseClockGroupsQueryOptions = QueryOpts<Base.ClockGroupsQuery, Base.ClockGroupsQueryVariables>;
export function useClockGroupsQuery(options?: UseClockGroupsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ClockGroupsQuery, Base.ClockGroupsQueryVariables>(Base.ClockGroupsDocument, options as any);
}
export type UseClockGroupsLazyQueryOptions = LazyQueryOpts<Base.ClockGroupsQueryVariables>;
export function useClockGroupsLazyQuery(options?: UseClockGroupsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ClockGroupsQuery, Base.ClockGroupsQueryVariables>(Base.ClockGroupsDocument, options as any);
}


// GetClockGroupsByNodeIdV2WithCounts
export type UseGetClockGroupsByNodeIdV2WithCountsQueryOptions = QueryOpts<Base.GetClockGroupsByNodeIdV2WithCountsQuery, Base.GetClockGroupsByNodeIdV2WithCountsQueryVariables>;
export function useGetClockGroupsByNodeIdV2WithCountsQuery(options?: UseGetClockGroupsByNodeIdV2WithCountsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetClockGroupsByNodeIdV2WithCountsQuery, Base.GetClockGroupsByNodeIdV2WithCountsQueryVariables>(Base.GetClockGroupsByNodeIdV2WithCountsDocument, options as any);
}
export type UseGetClockGroupsByNodeIdV2WithCountsLazyQueryOptions = LazyQueryOpts<Base.GetClockGroupsByNodeIdV2WithCountsQueryVariables>;
export function useGetClockGroupsByNodeIdV2WithCountsLazyQuery(options?: UseGetClockGroupsByNodeIdV2WithCountsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetClockGroupsByNodeIdV2WithCountsQuery, Base.GetClockGroupsByNodeIdV2WithCountsQueryVariables>(Base.GetClockGroupsByNodeIdV2WithCountsDocument, options as any);
}


// AddClockGroup
export type UseAddClockGroupMutationOptions = MutationOpts<Base.AddClockGroupMutation, Base.AddClockGroupMutationVariables>;
export function useAddClockGroupMutation(options?: UseAddClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddClockGroupMutation, Base.AddClockGroupMutationVariables>(Base.AddClockGroupDocument, options as any);
}


// UpdateClockGroup
export type UseUpdateClockGroupMutationOptions = MutationOpts<Base.UpdateClockGroupMutation, Base.UpdateClockGroupMutationVariables>;
export function useUpdateClockGroupMutation(options?: UseUpdateClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateClockGroupMutation, Base.UpdateClockGroupMutationVariables>(Base.UpdateClockGroupDocument, options as any);
}


// DeleteClockGroup
export type UseDeleteClockGroupMutationOptions = MutationOpts<Base.DeleteClockGroupMutation, Base.DeleteClockGroupMutationVariables>;
export function useDeleteClockGroupMutation(options?: UseDeleteClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteClockGroupMutation, Base.DeleteClockGroupMutationVariables>(Base.DeleteClockGroupDocument, options as any);
}


// DevicesFromClockGroup
export type UseDevicesFromClockGroupQueryOptions = QueryOpts<Base.DevicesFromClockGroupQuery, Base.DevicesFromClockGroupQueryVariables>;
export function useDevicesFromClockGroupQuery(options?: UseDevicesFromClockGroupQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DevicesFromClockGroupQuery, Base.DevicesFromClockGroupQueryVariables>(Base.DevicesFromClockGroupDocument, options as any);
}
export type UseDevicesFromClockGroupLazyQueryOptions = LazyQueryOpts<Base.DevicesFromClockGroupQueryVariables>;
export function useDevicesFromClockGroupLazyQuery(options?: UseDevicesFromClockGroupLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DevicesFromClockGroupQuery, Base.DevicesFromClockGroupQueryVariables>(Base.DevicesFromClockGroupDocument, options as any);
}


// DevicesNotFromClockGroup
export type UseDevicesNotFromClockGroupQueryOptions = QueryOpts<Base.DevicesNotFromClockGroupQuery, Base.DevicesNotFromClockGroupQueryVariables>;
export function useDevicesNotFromClockGroupQuery(options?: UseDevicesNotFromClockGroupQueryOptions | AnyQueryOpts) {
  return useQuery<Base.DevicesNotFromClockGroupQuery, Base.DevicesNotFromClockGroupQueryVariables>(Base.DevicesNotFromClockGroupDocument, options as any);
}
export type UseDevicesNotFromClockGroupLazyQueryOptions = LazyQueryOpts<Base.DevicesNotFromClockGroupQueryVariables>;
export function useDevicesNotFromClockGroupLazyQuery(options?: UseDevicesNotFromClockGroupLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.DevicesNotFromClockGroupQuery, Base.DevicesNotFromClockGroupQueryVariables>(Base.DevicesNotFromClockGroupDocument, options as any);
}


// GetAllClockGroupsForDevice
export type UseGetAllClockGroupsForDeviceQueryOptions = QueryOpts<Base.GetAllClockGroupsForDeviceQuery, Base.GetAllClockGroupsForDeviceQueryVariables>;
export function useGetAllClockGroupsForDeviceQuery(options?: UseGetAllClockGroupsForDeviceQueryOptions | AnyQueryOpts) {
  return useQuery<Base.GetAllClockGroupsForDeviceQuery, Base.GetAllClockGroupsForDeviceQueryVariables>(Base.GetAllClockGroupsForDeviceDocument, options as any);
}
export type UseGetAllClockGroupsForDeviceLazyQueryOptions = LazyQueryOpts<Base.GetAllClockGroupsForDeviceQueryVariables>;
export function useGetAllClockGroupsForDeviceLazyQuery(options?: UseGetAllClockGroupsForDeviceLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.GetAllClockGroupsForDeviceQuery, Base.GetAllClockGroupsForDeviceQueryVariables>(Base.GetAllClockGroupsForDeviceDocument, options as any);
}


// AddDevicesToClockGroup
export type UseAddDevicesToClockGroupMutationOptions = MutationOpts<Base.AddDevicesToClockGroupMutation, Base.AddDevicesToClockGroupMutationVariables>;
export function useAddDevicesToClockGroupMutation(options?: UseAddDevicesToClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddDevicesToClockGroupMutation, Base.AddDevicesToClockGroupMutationVariables>(Base.AddDevicesToClockGroupDocument, options as any);
}


// AddDeviceToClockGroup
export type UseAddDeviceToClockGroupMutationOptions = MutationOpts<Base.AddDeviceToClockGroupMutation, Base.AddDeviceToClockGroupMutationVariables>;
export function useAddDeviceToClockGroupMutation(options?: UseAddDeviceToClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddDeviceToClockGroupMutation, Base.AddDeviceToClockGroupMutationVariables>(Base.AddDeviceToClockGroupDocument, options as any);
}


// RemoveDevicesFromClockGroup
export type UseRemoveDevicesFromClockGroupMutationOptions = MutationOpts<Base.RemoveDevicesFromClockGroupMutation, Base.RemoveDevicesFromClockGroupMutationVariables>;
export function useRemoveDevicesFromClockGroupMutation(options?: UseRemoveDevicesFromClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RemoveDevicesFromClockGroupMutation, Base.RemoveDevicesFromClockGroupMutationVariables>(Base.RemoveDevicesFromClockGroupDocument, options as any);
}


// PeopleFromClockGroup
export type UsePeopleFromClockGroupQueryOptions = QueryOpts<Base.PeopleFromClockGroupQuery, Base.PeopleFromClockGroupQueryVariables>;
export function usePeopleFromClockGroupQuery(options?: UsePeopleFromClockGroupQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PeopleFromClockGroupQuery, Base.PeopleFromClockGroupQueryVariables>(Base.PeopleFromClockGroupDocument, options as any);
}
export type UsePeopleFromClockGroupLazyQueryOptions = LazyQueryOpts<Base.PeopleFromClockGroupQueryVariables>;
export function usePeopleFromClockGroupLazyQuery(options?: UsePeopleFromClockGroupLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PeopleFromClockGroupQuery, Base.PeopleFromClockGroupQueryVariables>(Base.PeopleFromClockGroupDocument, options as any);
}


// PeopleNotFromClockGroup
export type UsePeopleNotFromClockGroupQueryOptions = QueryOpts<Base.PeopleNotFromClockGroupQuery, Base.PeopleNotFromClockGroupQueryVariables>;
export function usePeopleNotFromClockGroupQuery(options?: UsePeopleNotFromClockGroupQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PeopleNotFromClockGroupQuery, Base.PeopleNotFromClockGroupQueryVariables>(Base.PeopleNotFromClockGroupDocument, options as any);
}
export type UsePeopleNotFromClockGroupLazyQueryOptions = LazyQueryOpts<Base.PeopleNotFromClockGroupQueryVariables>;
export function usePeopleNotFromClockGroupLazyQuery(options?: UsePeopleNotFromClockGroupLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PeopleNotFromClockGroupQuery, Base.PeopleNotFromClockGroupQueryVariables>(Base.PeopleNotFromClockGroupDocument, options as any);
}


// AddPeopleToClockGroup
export type UseAddPeopleToClockGroupMutationOptions = MutationOpts<Base.AddPeopleToClockGroupMutation, Base.AddPeopleToClockGroupMutationVariables>;
export function useAddPeopleToClockGroupMutation(options?: UseAddPeopleToClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddPeopleToClockGroupMutation, Base.AddPeopleToClockGroupMutationVariables>(Base.AddPeopleToClockGroupDocument, options as any);
}


// RemovePeopleFromClockGroup
export type UseRemovePeopleFromClockGroupMutationOptions = MutationOpts<Base.RemovePeopleFromClockGroupMutation, Base.RemovePeopleFromClockGroupMutationVariables>;
export function useRemovePeopleFromClockGroupMutation(options?: UseRemovePeopleFromClockGroupMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RemovePeopleFromClockGroupMutation, Base.RemovePeopleFromClockGroupMutationVariables>(Base.RemovePeopleFromClockGroupDocument, options as any);
}


// CompanyTransactions
export type UseCompanyTransactionsQueryOptions = QueryOpts<Base.CompanyTransactionsQuery, Base.CompanyTransactionsQueryVariables>;
export function useCompanyTransactionsQuery(options?: UseCompanyTransactionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CompanyTransactionsQuery, Base.CompanyTransactionsQueryVariables>(Base.CompanyTransactionsDocument, options as any);
}
export type UseCompanyTransactionsLazyQueryOptions = LazyQueryOpts<Base.CompanyTransactionsQueryVariables>;
export function useCompanyTransactionsLazyQuery(options?: UseCompanyTransactionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CompanyTransactionsQuery, Base.CompanyTransactionsQueryVariables>(Base.CompanyTransactionsDocument, options as any);
}


// TransactionByMessageId
export type UseTransactionByMessageIdQueryOptions = QueryOpts<Base.TransactionByMessageIdQuery, Base.TransactionByMessageIdQueryVariables>;
export function useTransactionByMessageIdQuery(options?: UseTransactionByMessageIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TransactionByMessageIdQuery, Base.TransactionByMessageIdQueryVariables>(Base.TransactionByMessageIdDocument, options as any);
}
export type UseTransactionByMessageIdLazyQueryOptions = LazyQueryOpts<Base.TransactionByMessageIdQueryVariables>;
export function useTransactionByMessageIdLazyQuery(options?: UseTransactionByMessageIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TransactionByMessageIdQuery, Base.TransactionByMessageIdQueryVariables>(Base.TransactionByMessageIdDocument, options as any);
}


// TransactionByCorrelationId
export type UseTransactionByCorrelationIdQueryOptions = QueryOpts<Base.TransactionByCorrelationIdQuery, Base.TransactionByCorrelationIdQueryVariables>;
export function useTransactionByCorrelationIdQuery(options?: UseTransactionByCorrelationIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TransactionByCorrelationIdQuery, Base.TransactionByCorrelationIdQueryVariables>(Base.TransactionByCorrelationIdDocument, options as any);
}
export type UseTransactionByCorrelationIdLazyQueryOptions = LazyQueryOpts<Base.TransactionByCorrelationIdQueryVariables>;
export function useTransactionByCorrelationIdLazyQuery(options?: UseTransactionByCorrelationIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TransactionByCorrelationIdQuery, Base.TransactionByCorrelationIdQueryVariables>(Base.TransactionByCorrelationIdDocument, options as any);
}


// PersonTransactions
export type UsePersonTransactionsQueryOptions = QueryOpts<Base.PersonTransactionsQuery, Base.PersonTransactionsQueryVariables>;
export function usePersonTransactionsQuery(options?: UsePersonTransactionsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PersonTransactionsQuery, Base.PersonTransactionsQueryVariables>(Base.PersonTransactionsDocument, options as any);
}
export type UsePersonTransactionsLazyQueryOptions = LazyQueryOpts<Base.PersonTransactionsQueryVariables>;
export function usePersonTransactionsLazyQuery(options?: UsePersonTransactionsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PersonTransactionsQuery, Base.PersonTransactionsQueryVariables>(Base.PersonTransactionsDocument, options as any);
}


// CompanyMetrics
export type UseCompanyMetricsQueryOptions = QueryOpts<Base.CompanyMetricsQuery, Base.CompanyMetricsQueryVariables>;
export function useCompanyMetricsQuery(options?: UseCompanyMetricsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CompanyMetricsQuery, Base.CompanyMetricsQueryVariables>(Base.CompanyMetricsDocument, options as any);
}
export type UseCompanyMetricsLazyQueryOptions = LazyQueryOpts<Base.CompanyMetricsQueryVariables>;
export function useCompanyMetricsLazyQuery(options?: UseCompanyMetricsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CompanyMetricsQuery, Base.CompanyMetricsQueryVariables>(Base.CompanyMetricsDocument, options as any);
}


// PeopleCompanyMetrics
export type UsePeopleCompanyMetricsQueryOptions = QueryOpts<Base.PeopleCompanyMetricsQuery, Base.PeopleCompanyMetricsQueryVariables>;
export function usePeopleCompanyMetricsQuery(options?: UsePeopleCompanyMetricsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PeopleCompanyMetricsQuery, Base.PeopleCompanyMetricsQueryVariables>(Base.PeopleCompanyMetricsDocument, options as any);
}
export type UsePeopleCompanyMetricsLazyQueryOptions = LazyQueryOpts<Base.PeopleCompanyMetricsQueryVariables>;
export function usePeopleCompanyMetricsLazyQuery(options?: UsePeopleCompanyMetricsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PeopleCompanyMetricsQuery, Base.PeopleCompanyMetricsQueryVariables>(Base.PeopleCompanyMetricsDocument, options as any);
}


// CredentialTypes
export type UseCredentialTypesQueryOptions = QueryOpts<Base.CredentialTypesQuery, Base.CredentialTypesQueryVariables>;
export function useCredentialTypesQuery(options?: UseCredentialTypesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CredentialTypesQuery, Base.CredentialTypesQueryVariables>(Base.CredentialTypesDocument, options as any);
}
export type UseCredentialTypesLazyQueryOptions = LazyQueryOpts<Base.CredentialTypesQueryVariables>;
export function useCredentialTypesLazyQuery(options?: UseCredentialTypesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CredentialTypesQuery, Base.CredentialTypesQueryVariables>(Base.CredentialTypesDocument, options as any);
}


// ConsentAgreements
export type UseConsentAgreementsQueryOptions = QueryOpts<Base.ConsentAgreementsQuery, Base.ConsentAgreementsQueryVariables>;
export function useConsentAgreementsQuery(options?: UseConsentAgreementsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ConsentAgreementsQuery, Base.ConsentAgreementsQueryVariables>(Base.ConsentAgreementsDocument, options as any);
}
export type UseConsentAgreementsLazyQueryOptions = LazyQueryOpts<Base.ConsentAgreementsQueryVariables>;
export function useConsentAgreementsLazyQuery(options?: UseConsentAgreementsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ConsentAgreementsQuery, Base.ConsentAgreementsQueryVariables>(Base.ConsentAgreementsDocument, options as any);
}


// AddConsentAgreement
export type UseAddConsentAgreementMutationOptions = MutationOpts<Base.AddConsentAgreementMutation, Base.AddConsentAgreementMutationVariables>;
export function useAddConsentAgreementMutation(options?: UseAddConsentAgreementMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddConsentAgreementMutation, Base.AddConsentAgreementMutationVariables>(Base.AddConsentAgreementDocument, options as any);
}


// UpdateConsentAgreement
export type UseUpdateConsentAgreementMutationOptions = MutationOpts<Base.UpdateConsentAgreementMutation, Base.UpdateConsentAgreementMutationVariables>;
export function useUpdateConsentAgreementMutation(options?: UseUpdateConsentAgreementMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateConsentAgreementMutation, Base.UpdateConsentAgreementMutationVariables>(Base.UpdateConsentAgreementDocument, options as any);
}


// DeleteConsentAgreement
export type UseDeleteConsentAgreementMutationOptions = MutationOpts<Base.DeleteConsentAgreementMutation, Base.DeleteConsentAgreementMutationVariables>;
export function useDeleteConsentAgreementMutation(options?: UseDeleteConsentAgreementMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteConsentAgreementMutation, Base.DeleteConsentAgreementMutationVariables>(Base.DeleteConsentAgreementDocument, options as any);
}


// ConsentAgreementTexts
export type UseConsentAgreementTextsQueryOptions = QueryOpts<Base.ConsentAgreementTextsQuery, Base.ConsentAgreementTextsQueryVariables>;
export function useConsentAgreementTextsQuery(options?: UseConsentAgreementTextsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ConsentAgreementTextsQuery, Base.ConsentAgreementTextsQueryVariables>(Base.ConsentAgreementTextsDocument, options as any);
}
export type UseConsentAgreementTextsLazyQueryOptions = LazyQueryOpts<Base.ConsentAgreementTextsQueryVariables>;
export function useConsentAgreementTextsLazyQuery(options?: UseConsentAgreementTextsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ConsentAgreementTextsQuery, Base.ConsentAgreementTextsQueryVariables>(Base.ConsentAgreementTextsDocument, options as any);
}


// AddConsentAgreementText
export type UseAddConsentAgreementTextMutationOptions = MutationOpts<Base.AddConsentAgreementTextMutation, Base.AddConsentAgreementTextMutationVariables>;
export function useAddConsentAgreementTextMutation(options?: UseAddConsentAgreementTextMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddConsentAgreementTextMutation, Base.AddConsentAgreementTextMutationVariables>(Base.AddConsentAgreementTextDocument, options as any);
}


// UpdateConsentAgreementText
export type UseUpdateConsentAgreementTextMutationOptions = MutationOpts<Base.UpdateConsentAgreementTextMutation, Base.UpdateConsentAgreementTextMutationVariables>;
export function useUpdateConsentAgreementTextMutation(options?: UseUpdateConsentAgreementTextMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateConsentAgreementTextMutation, Base.UpdateConsentAgreementTextMutationVariables>(Base.UpdateConsentAgreementTextDocument, options as any);
}


// DeleteConsentAgreementText
export type UseDeleteConsentAgreementTextMutationOptions = MutationOpts<Base.DeleteConsentAgreementTextMutation, Base.DeleteConsentAgreementTextMutationVariables>;
export function useDeleteConsentAgreementTextMutation(options?: UseDeleteConsentAgreementTextMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteConsentAgreementTextMutation, Base.DeleteConsentAgreementTextMutationVariables>(Base.DeleteConsentAgreementTextDocument, options as any);
}


// ConsentAgreementLinks
export type UseConsentAgreementLinksQueryOptions = QueryOpts<Base.ConsentAgreementLinksQuery, Base.ConsentAgreementLinksQueryVariables>;
export function useConsentAgreementLinksQuery(options?: UseConsentAgreementLinksQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ConsentAgreementLinksQuery, Base.ConsentAgreementLinksQueryVariables>(Base.ConsentAgreementLinksDocument, options as any);
}
export type UseConsentAgreementLinksLazyQueryOptions = LazyQueryOpts<Base.ConsentAgreementLinksQueryVariables>;
export function useConsentAgreementLinksLazyQuery(options?: UseConsentAgreementLinksLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ConsentAgreementLinksQuery, Base.ConsentAgreementLinksQueryVariables>(Base.ConsentAgreementLinksDocument, options as any);
}


// AddConsentAgreementLinks
export type UseAddConsentAgreementLinksMutationOptions = MutationOpts<Base.AddConsentAgreementLinksMutation, Base.AddConsentAgreementLinksMutationVariables>;
export function useAddConsentAgreementLinksMutation(options?: UseAddConsentAgreementLinksMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddConsentAgreementLinksMutation, Base.AddConsentAgreementLinksMutationVariables>(Base.AddConsentAgreementLinksDocument, options as any);
}


// DeleteConsentAgreementLinks
export type UseDeleteConsentAgreementLinksMutationOptions = MutationOpts<Base.DeleteConsentAgreementLinksMutation, Base.DeleteConsentAgreementLinksMutationVariables>;
export function useDeleteConsentAgreementLinksMutation(options?: UseDeleteConsentAgreementLinksMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteConsentAgreementLinksMutation, Base.DeleteConsentAgreementLinksMutationVariables>(Base.DeleteConsentAgreementLinksDocument, options as any);
}


// CoreData
export type UseCoreDataQueryOptions = QueryOpts<Base.CoreDataQuery, Base.CoreDataQueryVariables>;
export function useCoreDataQuery(options?: UseCoreDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CoreDataQuery, Base.CoreDataQueryVariables>(Base.CoreDataDocument, options as any);
}
export type UseCoreDataLazyQueryOptions = LazyQueryOpts<Base.CoreDataQueryVariables>;
export function useCoreDataLazyQuery(options?: UseCoreDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CoreDataQuery, Base.CoreDataQueryVariables>(Base.CoreDataDocument, options as any);
}


// ExtendedDataTypes
export type UseExtendedDataTypesQueryOptions = QueryOpts<Base.ExtendedDataTypesQuery, Base.ExtendedDataTypesQueryVariables>;
export function useExtendedDataTypesQuery(options?: UseExtendedDataTypesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExtendedDataTypesQuery, Base.ExtendedDataTypesQueryVariables>(Base.ExtendedDataTypesDocument, options as any);
}
export type UseExtendedDataTypesLazyQueryOptions = LazyQueryOpts<Base.ExtendedDataTypesQueryVariables>;
export function useExtendedDataTypesLazyQuery(options?: UseExtendedDataTypesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExtendedDataTypesQuery, Base.ExtendedDataTypesQueryVariables>(Base.ExtendedDataTypesDocument, options as any);
}


// ExtendedData
export type UseExtendedDataQueryOptions = QueryOpts<Base.ExtendedDataQuery, Base.ExtendedDataQueryVariables>;
export function useExtendedDataQuery(options?: UseExtendedDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExtendedDataQuery, Base.ExtendedDataQueryVariables>(Base.ExtendedDataDocument, options as any);
}
export type UseExtendedDataLazyQueryOptions = LazyQueryOpts<Base.ExtendedDataQueryVariables>;
export function useExtendedDataLazyQuery(options?: UseExtendedDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExtendedDataQuery, Base.ExtendedDataQueryVariables>(Base.ExtendedDataDocument, options as any);
}


// AddExtendedDataType
export type UseAddExtendedDataTypeMutationOptions = MutationOpts<Base.AddExtendedDataTypeMutation, Base.AddExtendedDataTypeMutationVariables>;
export function useAddExtendedDataTypeMutation(options?: UseAddExtendedDataTypeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddExtendedDataTypeMutation, Base.AddExtendedDataTypeMutationVariables>(Base.AddExtendedDataTypeDocument, options as any);
}


// UpdateExtendedDataType
export type UseUpdateExtendedDataTypeMutationOptions = MutationOpts<Base.UpdateExtendedDataTypeMutation, Base.UpdateExtendedDataTypeMutationVariables>;
export function useUpdateExtendedDataTypeMutation(options?: UseUpdateExtendedDataTypeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateExtendedDataTypeMutation, Base.UpdateExtendedDataTypeMutationVariables>(Base.UpdateExtendedDataTypeDocument, options as any);
}


// DeleteExtendedDataType
export type UseDeleteExtendedDataTypeMutationOptions = MutationOpts<Base.DeleteExtendedDataTypeMutation, Base.DeleteExtendedDataTypeMutationVariables>;
export function useDeleteExtendedDataTypeMutation(options?: UseDeleteExtendedDataTypeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteExtendedDataTypeMutation, Base.DeleteExtendedDataTypeMutationVariables>(Base.DeleteExtendedDataTypeDocument, options as any);
}


// ExtensionPoints
export type UseExtensionPointsQueryOptions = QueryOpts<Base.ExtensionPointsQuery, Base.ExtensionPointsQueryVariables>;
export function useExtensionPointsQuery(options?: UseExtensionPointsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ExtensionPointsQuery, Base.ExtensionPointsQueryVariables>(Base.ExtensionPointsDocument, options as any);
}
export type UseExtensionPointsLazyQueryOptions = LazyQueryOpts<Base.ExtensionPointsQueryVariables>;
export function useExtensionPointsLazyQuery(options?: UseExtensionPointsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ExtensionPointsQuery, Base.ExtensionPointsQueryVariables>(Base.ExtensionPointsDocument, options as any);
}


// JobCategories
export type UseJobCategoriesQueryOptions = QueryOpts<Base.JobCategoriesQuery, Base.JobCategoriesQueryVariables>;
export function useJobCategoriesQuery(options?: UseJobCategoriesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.JobCategoriesQuery, Base.JobCategoriesQueryVariables>(Base.JobCategoriesDocument, options as any);
}
export type UseJobCategoriesLazyQueryOptions = LazyQueryOpts<Base.JobCategoriesQueryVariables>;
export function useJobCategoriesLazyQuery(options?: UseJobCategoriesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.JobCategoriesQuery, Base.JobCategoriesQueryVariables>(Base.JobCategoriesDocument, options as any);
}


// AddJobCategory
export type UseAddJobCategoryMutationOptions = MutationOpts<Base.AddJobCategoryMutation, Base.AddJobCategoryMutationVariables>;
export function useAddJobCategoryMutation(options?: UseAddJobCategoryMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddJobCategoryMutation, Base.AddJobCategoryMutationVariables>(Base.AddJobCategoryDocument, options as any);
}


// UpdateJobCategory
export type UseUpdateJobCategoryMutationOptions = MutationOpts<Base.UpdateJobCategoryMutation, Base.UpdateJobCategoryMutationVariables>;
export function useUpdateJobCategoryMutation(options?: UseUpdateJobCategoryMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateJobCategoryMutation, Base.UpdateJobCategoryMutationVariables>(Base.UpdateJobCategoryDocument, options as any);
}


// DeleteJobCategory
export type UseDeleteJobCategoryMutationOptions = MutationOpts<Base.DeleteJobCategoryMutation, Base.DeleteJobCategoryMutationVariables>;
export function useDeleteJobCategoryMutation(options?: UseDeleteJobCategoryMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteJobCategoryMutation, Base.DeleteJobCategoryMutationVariables>(Base.DeleteJobCategoryDocument, options as any);
}


// JobCodes
export type UseJobCodesQueryOptions = QueryOpts<Base.JobCodesQuery, Base.JobCodesQueryVariables>;
export function useJobCodesQuery(options?: UseJobCodesQueryOptions | AnyQueryOpts) {
  return useQuery<Base.JobCodesQuery, Base.JobCodesQueryVariables>(Base.JobCodesDocument, options as any);
}
export type UseJobCodesLazyQueryOptions = LazyQueryOpts<Base.JobCodesQueryVariables>;
export function useJobCodesLazyQuery(options?: UseJobCodesLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.JobCodesQuery, Base.JobCodesQueryVariables>(Base.JobCodesDocument, options as any);
}


// AddJobCode
export type UseAddJobCodeMutationOptions = MutationOpts<Base.AddJobCodeMutation, Base.AddJobCodeMutationVariables>;
export function useAddJobCodeMutation(options?: UseAddJobCodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddJobCodeMutation, Base.AddJobCodeMutationVariables>(Base.AddJobCodeDocument, options as any);
}


// UpdateJobCode
export type UseUpdateJobCodeMutationOptions = MutationOpts<Base.UpdateJobCodeMutation, Base.UpdateJobCodeMutationVariables>;
export function useUpdateJobCodeMutation(options?: UseUpdateJobCodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateJobCodeMutation, Base.UpdateJobCodeMutationVariables>(Base.UpdateJobCodeDocument, options as any);
}


// DeleteJobCode
export type UseDeleteJobCodeMutationOptions = MutationOpts<Base.DeleteJobCodeMutation, Base.DeleteJobCodeMutationVariables>;
export function useDeleteJobCodeMutation(options?: UseDeleteJobCodeMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteJobCodeMutation, Base.DeleteJobCodeMutationVariables>(Base.DeleteJobCodeDocument, options as any);
}


// SupervisorOverridesByCompanyId
export type UseSupervisorOverridesByCompanyIdQueryOptions = QueryOpts<Base.SupervisorOverridesByCompanyIdQuery, Base.SupervisorOverridesByCompanyIdQueryVariables>;
export function useSupervisorOverridesByCompanyIdQuery(options?: UseSupervisorOverridesByCompanyIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.SupervisorOverridesByCompanyIdQuery, Base.SupervisorOverridesByCompanyIdQueryVariables>(Base.SupervisorOverridesByCompanyIdDocument, options as any);
}
export type UseSupervisorOverridesByCompanyIdLazyQueryOptions = LazyQueryOpts<Base.SupervisorOverridesByCompanyIdQueryVariables>;
export function useSupervisorOverridesByCompanyIdLazyQuery(options?: UseSupervisorOverridesByCompanyIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.SupervisorOverridesByCompanyIdQuery, Base.SupervisorOverridesByCompanyIdQueryVariables>(Base.SupervisorOverridesByCompanyIdDocument, options as any);
}


// FetchEditPersonData
export type UseFetchEditPersonDataQueryOptions = QueryOpts<Base.FetchEditPersonDataQuery, Base.FetchEditPersonDataQueryVariables>;
export function useFetchEditPersonDataQuery(options?: UseFetchEditPersonDataQueryOptions | AnyQueryOpts) {
  return useQuery<Base.FetchEditPersonDataQuery, Base.FetchEditPersonDataQueryVariables>(Base.FetchEditPersonDataDocument, options as any);
}
export type UseFetchEditPersonDataLazyQueryOptions = LazyQueryOpts<Base.FetchEditPersonDataQueryVariables>;
export function useFetchEditPersonDataLazyQuery(options?: UseFetchEditPersonDataLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.FetchEditPersonDataQuery, Base.FetchEditPersonDataQueryVariables>(Base.FetchEditPersonDataDocument, options as any);
}


// CompanyByNodeId
export type UseCompanyByNodeIdQueryOptions = QueryOpts<Base.CompanyByNodeIdQuery, Base.CompanyByNodeIdQueryVariables>;
export function useCompanyByNodeIdQuery(options?: UseCompanyByNodeIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CompanyByNodeIdQuery, Base.CompanyByNodeIdQueryVariables>(Base.CompanyByNodeIdDocument, options as any);
}
export type UseCompanyByNodeIdLazyQueryOptions = LazyQueryOpts<Base.CompanyByNodeIdQueryVariables>;
export function useCompanyByNodeIdLazyQuery(options?: UseCompanyByNodeIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CompanyByNodeIdQuery, Base.CompanyByNodeIdQueryVariables>(Base.CompanyByNodeIdDocument, options as any);
}


// PersonSummary
export type UsePersonSummaryQueryOptions = QueryOpts<Base.PersonSummaryQuery, Base.PersonSummaryQueryVariables>;
export function usePersonSummaryQuery(options?: UsePersonSummaryQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PersonSummaryQuery, Base.PersonSummaryQueryVariables>(Base.PersonSummaryDocument, options as any);
}
export type UsePersonSummaryLazyQueryOptions = LazyQueryOpts<Base.PersonSummaryQueryVariables>;
export function usePersonSummaryLazyQuery(options?: UsePersonSummaryLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PersonSummaryQuery, Base.PersonSummaryQueryVariables>(Base.PersonSummaryDocument, options as any);
}


// Person
export type UsePersonQueryOptions = QueryOpts<Base.PersonQuery, Base.PersonQueryVariables>;
export function usePersonQuery(options?: UsePersonQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PersonQuery, Base.PersonQueryVariables>(Base.PersonDocument, options as any);
}
export type UsePersonLazyQueryOptions = LazyQueryOpts<Base.PersonQueryVariables>;
export function usePersonLazyQuery(options?: UsePersonLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PersonQuery, Base.PersonQueryVariables>(Base.PersonDocument, options as any);
}


// TransactionPerson
export type UseTransactionPersonQueryOptions = QueryOpts<Base.TransactionPersonQuery, Base.TransactionPersonQueryVariables>;
export function useTransactionPersonQuery(options?: UseTransactionPersonQueryOptions | AnyQueryOpts) {
  return useQuery<Base.TransactionPersonQuery, Base.TransactionPersonQueryVariables>(Base.TransactionPersonDocument, options as any);
}
export type UseTransactionPersonLazyQueryOptions = LazyQueryOpts<Base.TransactionPersonQueryVariables>;
export function useTransactionPersonLazyQuery(options?: UseTransactionPersonLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.TransactionPersonQuery, Base.TransactionPersonQueryVariables>(Base.TransactionPersonDocument, options as any);
}


// PersonInfoCounts
export type UsePersonInfoCountsQueryOptions = QueryOpts<Base.PersonInfoCountsQuery, Base.PersonInfoCountsQueryVariables>;
export function usePersonInfoCountsQuery(options?: UsePersonInfoCountsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PersonInfoCountsQuery, Base.PersonInfoCountsQueryVariables>(Base.PersonInfoCountsDocument, options as any);
}
export type UsePersonInfoCountsLazyQueryOptions = LazyQueryOpts<Base.PersonInfoCountsQueryVariables>;
export function usePersonInfoCountsLazyQuery(options?: UsePersonInfoCountsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PersonInfoCountsQuery, Base.PersonInfoCountsQueryVariables>(Base.PersonInfoCountsDocument, options as any);
}


// People
export type UsePeopleQueryOptions = QueryOpts<Base.PeopleQuery, Base.PeopleQueryVariables>;
export function usePeopleQuery(options?: UsePeopleQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PeopleQuery, Base.PeopleQueryVariables>(Base.PeopleDocument, options as any);
}
export type UsePeopleLazyQueryOptions = LazyQueryOpts<Base.PeopleQueryVariables>;
export function usePeopleLazyQuery(options?: UsePeopleLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PeopleQuery, Base.PeopleQueryVariables>(Base.PeopleDocument, options as any);
}


// PeopleMissingConsent
export type UsePeopleMissingConsentQueryOptions = QueryOpts<Base.PeopleMissingConsentQuery, Base.PeopleMissingConsentQueryVariables>;
export function usePeopleMissingConsentQuery(options?: UsePeopleMissingConsentQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PeopleMissingConsentQuery, Base.PeopleMissingConsentQueryVariables>(Base.PeopleMissingConsentDocument, options as any);
}
export type UsePeopleMissingConsentLazyQueryOptions = LazyQueryOpts<Base.PeopleMissingConsentQueryVariables>;
export function usePeopleMissingConsentLazyQuery(options?: UsePeopleMissingConsentLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PeopleMissingConsentQuery, Base.PeopleMissingConsentQueryVariables>(Base.PeopleMissingConsentDocument, options as any);
}


// PersonClockGroups
export type UsePersonClockGroupsQueryOptions = QueryOpts<Base.PersonClockGroupsQuery, Base.PersonClockGroupsQueryVariables>;
export function usePersonClockGroupsQuery(options?: UsePersonClockGroupsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.PersonClockGroupsQuery, Base.PersonClockGroupsQueryVariables>(Base.PersonClockGroupsDocument, options as any);
}
export type UsePersonClockGroupsLazyQueryOptions = LazyQueryOpts<Base.PersonClockGroupsQueryVariables>;
export function usePersonClockGroupsLazyQuery(options?: UsePersonClockGroupsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.PersonClockGroupsQuery, Base.PersonClockGroupsQueryVariables>(Base.PersonClockGroupsDocument, options as any);
}


// AddPerson
export type UseAddPersonMutationOptions = MutationOpts<Base.AddPersonMutation, Base.AddPersonMutationVariables>;
export function useAddPersonMutation(options?: UseAddPersonMutationOptions | AnyMutationOpts) {
  return useMutation<Base.AddPersonMutation, Base.AddPersonMutationVariables>(Base.AddPersonDocument, options as any);
}


// UpdatePerson
export type UseUpdatePersonMutationOptions = MutationOpts<Base.UpdatePersonMutation, Base.UpdatePersonMutationVariables>;
export function useUpdatePersonMutation(options?: UseUpdatePersonMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdatePersonMutation, Base.UpdatePersonMutationVariables>(Base.UpdatePersonDocument, options as any);
}


// Consents
export type UseConsentsQueryOptions = QueryOpts<Base.ConsentsQuery, Base.ConsentsQueryVariables>;
export function useConsentsQuery(options?: UseConsentsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.ConsentsQuery, Base.ConsentsQueryVariables>(Base.ConsentsDocument, options as any);
}
export type UseConsentsLazyQueryOptions = LazyQueryOpts<Base.ConsentsQueryVariables>;
export function useConsentsLazyQuery(options?: UseConsentsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.ConsentsQuery, Base.ConsentsQueryVariables>(Base.ConsentsDocument, options as any);
}


// Credentials
export type UseCredentialsQueryOptions = QueryOpts<Base.CredentialsQuery, Base.CredentialsQueryVariables>;
export function useCredentialsQuery(options?: UseCredentialsQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CredentialsQuery, Base.CredentialsQueryVariables>(Base.CredentialsDocument, options as any);
}
export type UseCredentialsLazyQueryOptions = LazyQueryOpts<Base.CredentialsQueryVariables>;
export function useCredentialsLazyQuery(options?: UseCredentialsLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CredentialsQuery, Base.CredentialsQueryVariables>(Base.CredentialsDocument, options as any);
}


// DeletePerson
export type UseDeletePersonMutationOptions = MutationOpts<Base.DeletePersonMutation, Base.DeletePersonMutationVariables>;
export function useDeletePersonMutation(options?: UseDeletePersonMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeletePersonMutation, Base.DeletePersonMutationVariables>(Base.DeletePersonDocument, options as any);
}


// DeleteCredential
export type UseDeleteCredentialMutationOptions = MutationOpts<Base.DeleteCredentialMutation, Base.DeleteCredentialMutationVariables>;
export function useDeleteCredentialMutation(options?: UseDeleteCredentialMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteCredentialMutation, Base.DeleteCredentialMutationVariables>(Base.DeleteCredentialDocument, options as any);
}


// IssueCredential
export type UseIssueCredentialMutationOptions = MutationOpts<Base.IssueCredentialMutation, Base.IssueCredentialMutationVariables>;
export function useIssueCredentialMutation(options?: UseIssueCredentialMutationOptions | AnyMutationOpts) {
  return useMutation<Base.IssueCredentialMutation, Base.IssueCredentialMutationVariables>(Base.IssueCredentialDocument, options as any);
}


// RevokeCredential
export type UseRevokeCredentialMutationOptions = MutationOpts<Base.RevokeCredentialMutation, Base.RevokeCredentialMutationVariables>;
export function useRevokeCredentialMutation(options?: UseRevokeCredentialMutationOptions | AnyMutationOpts) {
  return useMutation<Base.RevokeCredentialMutation, Base.RevokeCredentialMutationVariables>(Base.RevokeCredentialDocument, options as any);
}


// DeleteConsent
export type UseDeleteConsentMutationOptions = MutationOpts<Base.DeleteConsentMutation, Base.DeleteConsentMutationVariables>;
export function useDeleteConsentMutation(options?: UseDeleteConsentMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteConsentMutation, Base.DeleteConsentMutationVariables>(Base.DeleteConsentDocument, options as any);
}


// UpdatePersonJobCodes
export type UseUpdatePersonJobCodesMutationOptions = MutationOpts<Base.UpdatePersonJobCodesMutation, Base.UpdatePersonJobCodesMutationVariables>;
export function useUpdatePersonJobCodesMutation(options?: UseUpdatePersonJobCodesMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdatePersonJobCodesMutation, Base.UpdatePersonJobCodesMutationVariables>(Base.UpdatePersonJobCodesDocument, options as any);
}


// CredentialProviders
export type UseCredentialProvidersQueryOptions = QueryOpts<Base.CredentialProvidersQuery, Base.CredentialProvidersQueryVariables>;
export function useCredentialProvidersQuery(options?: UseCredentialProvidersQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CredentialProvidersQuery, Base.CredentialProvidersQueryVariables>(Base.CredentialProvidersDocument, options as any);
}
export type UseCredentialProvidersLazyQueryOptions = LazyQueryOpts<Base.CredentialProvidersQueryVariables>;
export function useCredentialProvidersLazyQuery(options?: UseCredentialProvidersLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CredentialProvidersQuery, Base.CredentialProvidersQueryVariables>(Base.CredentialProvidersDocument, options as any);
}


// CredentialProviderById
export type UseCredentialProviderByIdQueryOptions = QueryOpts<Base.CredentialProviderByIdQuery, Base.CredentialProviderByIdQueryVariables>;
export function useCredentialProviderByIdQuery(options?: UseCredentialProviderByIdQueryOptions | AnyQueryOpts) {
  return useQuery<Base.CredentialProviderByIdQuery, Base.CredentialProviderByIdQueryVariables>(Base.CredentialProviderByIdDocument, options as any);
}
export type UseCredentialProviderByIdLazyQueryOptions = LazyQueryOpts<Base.CredentialProviderByIdQueryVariables>;
export function useCredentialProviderByIdLazyQuery(options?: UseCredentialProviderByIdLazyQueryOptions | AnyLazyQueryOpts) {
  return useLazyQuery<Base.CredentialProviderByIdQuery, Base.CredentialProviderByIdQueryVariables>(Base.CredentialProviderByIdDocument, options as any);
}


// CreateCredentialProvider
export type UseCreateCredentialProviderMutationOptions = MutationOpts<Base.CreateCredentialProviderMutation, Base.CreateCredentialProviderMutationVariables>;
export function useCreateCredentialProviderMutation(options?: UseCreateCredentialProviderMutationOptions | AnyMutationOpts) {
  return useMutation<Base.CreateCredentialProviderMutation, Base.CreateCredentialProviderMutationVariables>(Base.CreateCredentialProviderDocument, options as any);
}


// UpdateCredentialProvider
export type UseUpdateCredentialProviderMutationOptions = MutationOpts<Base.UpdateCredentialProviderMutation, Base.UpdateCredentialProviderMutationVariables>;
export function useUpdateCredentialProviderMutation(options?: UseUpdateCredentialProviderMutationOptions | AnyMutationOpts) {
  return useMutation<Base.UpdateCredentialProviderMutation, Base.UpdateCredentialProviderMutationVariables>(Base.UpdateCredentialProviderDocument, options as any);
}


// DeleteCredentialProvider
export type UseDeleteCredentialProviderMutationOptions = MutationOpts<Base.DeleteCredentialProviderMutation, Base.DeleteCredentialProviderMutationVariables>;
export function useDeleteCredentialProviderMutation(options?: UseDeleteCredentialProviderMutationOptions | AnyMutationOpts) {
  return useMutation<Base.DeleteCredentialProviderMutation, Base.DeleteCredentialProviderMutationVariables>(Base.DeleteCredentialProviderDocument, options as any);
}


// SubmitFeatureSuggestion
export type UseSubmitFeatureSuggestionMutationOptions = MutationOpts<Base.SubmitFeatureSuggestionMutation, Base.SubmitFeatureSuggestionMutationVariables>;
export function useSubmitFeatureSuggestionMutation(options?: UseSubmitFeatureSuggestionMutationOptions | AnyMutationOpts) {
  return useMutation<Base.SubmitFeatureSuggestionMutation, Base.SubmitFeatureSuggestionMutationVariables>(Base.SubmitFeatureSuggestionDocument, options as any);
}

export * from './base/graphql';